// @generated by protobuf-ts 2.8.1 with parameter optimize_code_size,output_legacy_commonjs,output_javascript
// @generated from protobuf file "v2/concordium/types.proto" (package "concordium.v2", syntax proto3)
// tslint:disable
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinningBaker = exports.BlockCertificates = exports.EpochFinalizationEntry = exports.SuccessorProof = exports.TimeoutCertificate = exports.TimeoutSignature = exports.FinalizerRound = exports.QuorumCertificate = exports.QuorumSignature = exports.BakerRewardPeriodInfo = exports.BlockItem = exports.BlockFinalizationSummary = exports.FinalizationSummary = exports.FinalizationIndex = exports.FinalizationSummaryParty = exports.ChainParameters = exports.ChainParametersV2 = exports.ChainParametersV1 = exports.ChainParametersV0 = exports.CredentialsPerBlockLimit = exports.AccountTransactionSignHash = exports.UpdateInstruction = exports.UpdateInstructionPayload = exports.UpdateInstructionHeader = exports.UpdateInstructionSignature = exports.AccountTransaction = exports.PreAccountTransaction = exports.AccountTransactionPayload = exports.TransferWithMemoPayload = exports.TransferPayload = exports.UpdateContractPayload = exports.InitContractPayload = exports.AccountTransactionHeader = exports.AccountTransactionSignature = exports.AccountSignatureMap = exports.SignatureMap = exports.Signature = exports.CredentialDeployment = exports.SendBlockItemRequest = exports.NodeInfo_Node = exports.NodeInfo_BakerConsensusInfo_ActiveFinalizerCommitteeInfo = exports.NodeInfo_BakerConsensusInfo_ActiveBakerCommitteeInfo = exports.NodeInfo_BakerConsensusInfo = exports.NodeInfo_NetworkInfo = exports.NodeInfo = exports.PeersInfo_Peer_NetworkStats = exports.PeersInfo_Peer = exports.PeersInfo = exports.DumpRequest = exports.PeerToBan = exports.BannedPeers = exports.BannedPeer = exports.PeerId = exports.IpSocketAddress = exports.Port = exports.IpAddress = exports.NextUpdateSequenceNumbers = exports.PendingUpdate = exports.BlockSpecialEvent_PaydayPoolReward = exports.BlockSpecialEvent_BlockAccrueReward = exports.BlockSpecialEvent_PaydayAccountReward = exports.BlockSpecialEvent_PaydayFoundationReward = exports.BlockSpecialEvent_BlockReward = exports.BlockSpecialEvent_FinalizationRewards = exports.BlockSpecialEvent_Mint = exports.BlockSpecialEvent_BakingRewards = exports.BlockSpecialEvent_AccountAmounts_Entry = exports.BlockSpecialEvent_AccountAmounts = exports.BlockSpecialEvent = exports.ElectionInfo_Baker = exports.ElectionInfo = exports.LeadershipElectionNonce = exports.Branch = exports.DelegatorRewardPeriodInfo = exports.DelegatorInfo = exports.GetPoolDelegatorsRequest = exports.InvokeInstanceResponse_Success = exports.InvokeInstanceResponse_Failure = exports.InvokeInstanceResponse = exports.InvokeInstanceRequest = exports.TokenomicsInfo_V1 = exports.TokenomicsInfo_V0 = exports.TokenomicsInfo = exports.BlocksAtHeightResponse = exports.BlocksAtHeightRequest_Relative = exports.BlocksAtHeightRequest_Absolute = exports.BlocksAtHeightRequest = exports.PassiveDelegationInfo = exports.PoolInfoResponse = exports.PoolCurrentPaydayInfo = exports.PoolPendingChange_Remove = exports.PoolPendingChange_Reduce = exports.PoolPendingChange = exports.PoolInfoRequest = exports.BlockInfo = exports.CryptographicParameters = exports.ArrivedBlockInfo = exports.ConsensusInfo = exports.GenesisIndex = exports.BlockItemSummary_TransactionIndex = exports.BlockItemSummary = exports.UpdateDetails = exports.TransactionTime = exports.AccountCreationDetails = exports.AccountTransactionDetails = exports.UpdatePayload = exports.Level1Update = exports.RootUpdate = exports.BakerStakeThreshold = exports.GasRewardsCpv2 = exports.GasRewards = exports.TransactionFeeDistribution = exports.MintDistributionCpv0 = exports.ProtocolUpdate = exports.MintDistributionCpv1 = exports.TimeParametersCpv1 = exports.PoolParametersCpv1 = exports.CooldownParametersCpv1 = exports.MintRate = exports.RewardPeriodLength = exports.Round = exports.Epoch = exports.LeverageFactor = exports.CapitalBound = exports.CommissionRanges = exports.InclusiveRangeAmountFraction = exports.DurationSeconds = exports.IpInfo_IpCdiVerifyKey = exports.IpInfo_IpVerifyKey = exports.IpInfo = exports.IpIdentity = exports.ArInfo_ArPublicKey = exports.ArInfo_ArIdentity = exports.ArInfo = exports.Description = exports.AuthorizationsV1 = exports.AuthorizationsV0 = exports.AccessStructure = exports.HigherLevelKeys = exports.UpdateKeysIndex = exports.UpdateKeysThreshold = exports.UpdatePublicKey = exports.Ratio = exports.ExchangeRate = exports.ConsensusParametersV1 = exports.FinalizationCommitteeParameters = exports.TimeoutParameters = exports.ElectionDifficulty = exports.AccountTransactionEffects_DelegationConfigured = exports.AccountTransactionEffects_BakerConfigured = exports.AccountTransactionEffects_CredentialsUpdated = exports.AccountTransactionEffects_TransferredWithSchedule = exports.AccountTransactionEffects_TransferredToPublic = exports.AccountTransactionEffects_EncryptedAmountTransferred = exports.AccountTransactionEffects_BakerStakeUpdated = exports.AccountTransactionEffects_AccountTransfer = exports.AccountTransactionEffects_ContractUpdateIssued = exports.AccountTransactionEffects_None = exports.AccountTransactionEffects = exports.DelegationEvent_DelegationSetDelegationTarget = exports.DelegationEvent_DelegationSetRestakeEarnings = exports.DelegationEvent_DelegationStakeDecreased = exports.DelegationEvent_DelegationStakeIncreased = exports.DelegationEvent = exports.DelegatorId = exports.BakerEvent_BakerSetFinalizationRewardCommission = exports.BakerEvent_BakerSetBakingRewardCommission = exports.BakerEvent_BakerSetTransactionFeeCommission = exports.BakerEvent_BakerSetMetadataUrl = exports.BakerEvent_BakerSetOpenStatus = exports.BakerEvent_BakerRestakeEarningsUpdated = exports.BakerEvent_BakerStakeDecreased = exports.BakerEvent_BakerStakeIncreased = exports.BakerEvent_BakerAdded = exports.BakerEvent = exports.RegisteredData = exports.EncryptedSelfAmountAddedEvent = exports.NewEncryptedAmountEvent = exports.EncryptedAmountRemovedEvent = exports.BakerStakeUpdatedData = exports.Memo = exports.BakerKeysEvent = exports.ContractTraceElement_Upgraded = exports.ContractTraceElement_Resumed = exports.ContractTraceElement_Interrupted = exports.ContractTraceElement_Transferred = exports.ContractTraceElement = exports.InstanceUpdatedEvent = exports.ContractEvent = exports.ContractInitializedEvent = exports.RejectReason_NonExistentCredIds = exports.RejectReason_DuplicateCredIds = exports.RejectReason_RejectedReceive = exports.RejectReason_RejectedInit = exports.RejectReason_AmountTooLarge = exports.RejectReason_InvalidReceiveMethod = exports.RejectReason_InvalidInitMethod = exports.RejectReason = exports.Duration = exports.NextAccountSequenceNumber = exports.Slot = exports.Energy = exports.BlockItemSummaryInBlock = exports.BlockItemStatus_Finalized = exports.BlockItemStatus_Committed = exports.BlockItemStatus = exports.ContractStateV0 = exports.Parameter = exports.InitName = exports.ReceiveName = exports.InstanceStateValueAtKey = exports.InstanceStateLookupRequest = exports.InstanceStateKVPair = exports.InstanceInfo_V1 = exports.InstanceInfo_V0 = exports.InstanceInfo = exports.InstanceInfoRequest = exports.ContractAddress = exports.ModuleSourceRequest = exports.AncestorsRequest = exports.FinalizedBlockInfo = exports.AccountInfoRequest = exports.AccountIdentifierInput = exports.EpochRequest_RelativeEpoch = exports.EpochRequest = exports.BlockHashInput_RelativeHeight = exports.BlockHashInput = exports.AccountInfo = exports.AccountCredential = exports.NormalCredentialValues = exports.CredentialCommitments = exports.Commitment = exports.ArThreshold = exports.ChainArData = exports.InitialCredentialValues = exports.Policy = exports.YearMonth = exports.IdentityProviderIdentity = exports.CredentialRegistrationId = exports.CredentialPublicKeys = exports.AccountVerifyKey = exports.Address = exports.AccountAddress = exports.EncryptionKey = exports.AccountThreshold = exports.SignatureThreshold = exports.CredentialIndex = exports.Amount = exports.UpdateSequenceNumber = exports.SequenceNumber = exports.AccountStakingInfo_Delegator = exports.AccountStakingInfo_Baker = exports.AccountStakingInfo = exports.BakerPoolInfo = exports.CommissionRates = exports.AmountFraction = exports.StakePendingChange_Reduce = exports.StakePendingChange = exports.BakerInfo = exports.BakerAggregationVerifyKey = exports.BakerSignatureVerifyKey = exports.BakerElectionVerifyKey = exports.DelegationTarget = exports.EncryptedBalance = exports.EncryptedAmount = exports.ReleaseSchedule = exports.NewRelease = exports.Release = exports.Timestamp = exports.VersionedModuleSource_ModuleSourceV1 = exports.VersionedModuleSource_ModuleSourceV0 = exports.VersionedModuleSource = exports.ModuleRef = exports.AccountIndex = exports.BakerId = exports.BlockHeight = exports.AbsoluteBlockHeight = exports.StateHash = exports.TransactionHash = exports.Sha256Hash = exports.BlockHash = exports.Empty = exports.ProtocolVersion = exports.TransactionType = exports.UpdateType = exports.CredentialType = exports.ContractVersion = exports.OpenStatus = exports.NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo = exports.PeersInfo_Peer_CatchupStatus = void 0;
// @generated by protobuf-ts 2.8.1 with parameter optimize_code_size,output_legacy_commonjs,output_javascript
// @generated from protobuf file "v2/concordium/types.proto" (package "concordium.v2", syntax proto3)
// tslint:disable
const runtime_1 = require("@protobuf-ts/runtime");
/**
 * @generated from protobuf enum concordium.v2.PeersInfo.Peer.CatchupStatus
 */
var PeersInfo_Peer_CatchupStatus;
(function (PeersInfo_Peer_CatchupStatus) {
    /**
     * The peer does not have any data unknown to us. If we receive a message from the
     * peer that refers to unknown data (e.g., an unknown block) the peer is marked as pending.
     *
     * @generated from protobuf enum value: UPTODATE = 0;
     */
    PeersInfo_Peer_CatchupStatus[PeersInfo_Peer_CatchupStatus["UPTODATE"] = 0] = "UPTODATE";
    /**
     * The peer might have some data unknown to us. A peer can be in this state either because
     * it sent a message that refers to data unknown to us, or before we have established a baseline with it.
     * The latter happens during node startup, as well as upon protocol updates until the initial catchup handshake
     * completes.
     *
     * @generated from protobuf enum value: PENDING = 1;
     */
    PeersInfo_Peer_CatchupStatus[PeersInfo_Peer_CatchupStatus["PENDING"] = 1] = "PENDING";
    /**
     * The node is currently catching up by requesting blocks from this peer.
     * There will be at most one peer with this status at a time.
     * Once the peer has responded to the request, its status will be changed to:
     * - 'UPTODATE' if the peer has no more data that is not known to us
     * - 'PENDING' if the node has more data that is unknown to us.
     *
     * @generated from protobuf enum value: CATCHINGUP = 2;
     */
    PeersInfo_Peer_CatchupStatus[PeersInfo_Peer_CatchupStatus["CATCHINGUP"] = 2] = "CATCHINGUP";
})(PeersInfo_Peer_CatchupStatus = exports.PeersInfo_Peer_CatchupStatus || (exports.PeersInfo_Peer_CatchupStatus = {}));
/**
 * The committee information of a node configured with
 * baker keys but somehow the node is _not_ part of the
 * current baking committee.
 *
 * @generated from protobuf enum concordium.v2.NodeInfo.BakerConsensusInfo.PassiveCommitteeInfo
 */
var NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo;
(function (NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo) {
    /**
     * The node is started with baker keys however it is currently not in the baking committee.
     * The node is __not__ baking.
     *
     * @generated from protobuf enum value: NOT_IN_COMMITTEE = 0;
     */
    NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo[NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo["NOT_IN_COMMITTEE"] = 0] = "NOT_IN_COMMITTEE";
    /**
     * The account is registered as a baker but not in the current `Epoch`.
     * The node is __not__ baking.
     *
     * @generated from protobuf enum value: ADDED_BUT_NOT_ACTIVE_IN_COMMITTEE = 1;
     */
    NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo[NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo["ADDED_BUT_NOT_ACTIVE_IN_COMMITTEE"] = 1] = "ADDED_BUT_NOT_ACTIVE_IN_COMMITTEE";
    /**
     * The node has configured invalid baker keys i.e., the configured
     * baker keys do not match the current keys on the baker account.
     * The node is __not__ baking.
     *
     * @generated from protobuf enum value: ADDED_BUT_WRONG_KEYS = 2;
     */
    NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo[NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo["ADDED_BUT_WRONG_KEYS"] = 2] = "ADDED_BUT_WRONG_KEYS";
})(NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo = exports.NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo || (exports.NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo = {}));
/**
 * Information about how open the pool is to new delegators.
 *
 * @generated from protobuf enum concordium.v2.OpenStatus
 */
var OpenStatus;
(function (OpenStatus) {
    /**
     * @generated from protobuf enum value: OPEN_STATUS_OPEN_FOR_ALL = 0;
     */
    OpenStatus[OpenStatus["OPEN_FOR_ALL"] = 0] = "OPEN_FOR_ALL";
    /**
     * @generated from protobuf enum value: OPEN_STATUS_CLOSED_FOR_NEW = 1;
     */
    OpenStatus[OpenStatus["CLOSED_FOR_NEW"] = 1] = "CLOSED_FOR_NEW";
    /**
     * @generated from protobuf enum value: OPEN_STATUS_CLOSED_FOR_ALL = 2;
     */
    OpenStatus[OpenStatus["CLOSED_FOR_ALL"] = 2] = "CLOSED_FOR_ALL";
})(OpenStatus = exports.OpenStatus || (exports.OpenStatus = {}));
/**
 * Version of smart contract.
 *
 * @generated from protobuf enum concordium.v2.ContractVersion
 */
var ContractVersion;
(function (ContractVersion) {
    /**
     * @generated from protobuf enum value: V0 = 0;
     */
    ContractVersion[ContractVersion["V0"] = 0] = "V0";
    /**
     * @generated from protobuf enum value: V1 = 1;
     */
    ContractVersion[ContractVersion["V1"] = 1] = "V1";
})(ContractVersion = exports.ContractVersion || (exports.ContractVersion = {}));
/**
 * The type of a credential.
 *
 * @generated from protobuf enum concordium.v2.CredentialType
 */
var CredentialType;
(function (CredentialType) {
    /**
     * An initial credential created by the identity provider.
     *
     * @generated from protobuf enum value: CREDENTIAL_TYPE_INITIAL = 0;
     */
    CredentialType[CredentialType["INITIAL"] = 0] = "INITIAL";
    /**
     * A normal credential type created by the account.
     *
     * @generated from protobuf enum value: CREDENTIAL_TYPE_NORMAL = 1;
     */
    CredentialType[CredentialType["NORMAL"] = 1] = "NORMAL";
})(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
/**
 * The type of chain update.
 *
 * @generated from protobuf enum concordium.v2.UpdateType
 */
var UpdateType;
(function (UpdateType) {
    /**
     * @generated from protobuf enum value: UPDATE_PROTOCOL = 0;
     */
    UpdateType[UpdateType["UPDATE_PROTOCOL"] = 0] = "UPDATE_PROTOCOL";
    /**
     * @generated from protobuf enum value: UPDATE_ELECTION_DIFFICULTY = 1;
     */
    UpdateType[UpdateType["UPDATE_ELECTION_DIFFICULTY"] = 1] = "UPDATE_ELECTION_DIFFICULTY";
    /**
     * @generated from protobuf enum value: UPDATE_EURO_PER_ENERGY = 2;
     */
    UpdateType[UpdateType["UPDATE_EURO_PER_ENERGY"] = 2] = "UPDATE_EURO_PER_ENERGY";
    /**
     * @generated from protobuf enum value: UPDATE_MICRO_CCD_PER_EURO = 3;
     */
    UpdateType[UpdateType["UPDATE_MICRO_CCD_PER_EURO"] = 3] = "UPDATE_MICRO_CCD_PER_EURO";
    /**
     * @generated from protobuf enum value: UPDATE_FOUNDATION_ACCOUNT = 4;
     */
    UpdateType[UpdateType["UPDATE_FOUNDATION_ACCOUNT"] = 4] = "UPDATE_FOUNDATION_ACCOUNT";
    /**
     * @generated from protobuf enum value: UPDATE_MINT_DISTRIBUTION = 5;
     */
    UpdateType[UpdateType["UPDATE_MINT_DISTRIBUTION"] = 5] = "UPDATE_MINT_DISTRIBUTION";
    /**
     * @generated from protobuf enum value: UPDATE_TRANSACTION_FEE_DISTRIBUTION = 6;
     */
    UpdateType[UpdateType["UPDATE_TRANSACTION_FEE_DISTRIBUTION"] = 6] = "UPDATE_TRANSACTION_FEE_DISTRIBUTION";
    /**
     * @generated from protobuf enum value: UPDATE_GAS_REWARDS = 7;
     */
    UpdateType[UpdateType["UPDATE_GAS_REWARDS"] = 7] = "UPDATE_GAS_REWARDS";
    /**
     * @generated from protobuf enum value: UPDATE_POOL_PARAMETERS = 8;
     */
    UpdateType[UpdateType["UPDATE_POOL_PARAMETERS"] = 8] = "UPDATE_POOL_PARAMETERS";
    /**
     * @generated from protobuf enum value: ADD_ANONYMITY_REVOKER = 9;
     */
    UpdateType[UpdateType["ADD_ANONYMITY_REVOKER"] = 9] = "ADD_ANONYMITY_REVOKER";
    /**
     * @generated from protobuf enum value: ADD_IDENTITY_PROVIDER = 10;
     */
    UpdateType[UpdateType["ADD_IDENTITY_PROVIDER"] = 10] = "ADD_IDENTITY_PROVIDER";
    /**
     * @generated from protobuf enum value: UPDATE_ROOT_KEYS = 11;
     */
    UpdateType[UpdateType["UPDATE_ROOT_KEYS"] = 11] = "UPDATE_ROOT_KEYS";
    /**
     * @generated from protobuf enum value: UPDATE_LEVEL1_KEYS = 12;
     */
    UpdateType[UpdateType["UPDATE_LEVEL1_KEYS"] = 12] = "UPDATE_LEVEL1_KEYS";
    /**
     * @generated from protobuf enum value: UPDATE_LEVEL2_KEYS = 13;
     */
    UpdateType[UpdateType["UPDATE_LEVEL2_KEYS"] = 13] = "UPDATE_LEVEL2_KEYS";
    /**
     * @generated from protobuf enum value: UPDATE_COOLDOWN_PARAMETERS = 14;
     */
    UpdateType[UpdateType["UPDATE_COOLDOWN_PARAMETERS"] = 14] = "UPDATE_COOLDOWN_PARAMETERS";
    /**
     * @generated from protobuf enum value: UPDATE_TIME_PARAMETERS = 15;
     */
    UpdateType[UpdateType["UPDATE_TIME_PARAMETERS"] = 15] = "UPDATE_TIME_PARAMETERS";
    /**
     * @generated from protobuf enum value: UPDATE_TIMEOUT_PARAMETERS = 16;
     */
    UpdateType[UpdateType["UPDATE_TIMEOUT_PARAMETERS"] = 16] = "UPDATE_TIMEOUT_PARAMETERS";
    /**
     * @generated from protobuf enum value: UPDATE_MIN_BLOCK_TIME = 17;
     */
    UpdateType[UpdateType["UPDATE_MIN_BLOCK_TIME"] = 17] = "UPDATE_MIN_BLOCK_TIME";
    /**
     * @generated from protobuf enum value: UPDATE_BLOCK_ENERGY_LIMIT = 18;
     */
    UpdateType[UpdateType["UPDATE_BLOCK_ENERGY_LIMIT"] = 18] = "UPDATE_BLOCK_ENERGY_LIMIT";
    /**
     * @generated from protobuf enum value: UPDATE_FINALIZATION_COMMITTEE_PARAMETERS = 19;
     */
    UpdateType[UpdateType["UPDATE_FINALIZATION_COMMITTEE_PARAMETERS"] = 19] = "UPDATE_FINALIZATION_COMMITTEE_PARAMETERS";
})(UpdateType = exports.UpdateType || (exports.UpdateType = {}));
/**
 * The type of transaction.
 *
 * @generated from protobuf enum concordium.v2.TransactionType
 */
var TransactionType;
(function (TransactionType) {
    /**
     * @generated from protobuf enum value: DEPLOY_MODULE = 0;
     */
    TransactionType[TransactionType["DEPLOY_MODULE"] = 0] = "DEPLOY_MODULE";
    /**
     * @generated from protobuf enum value: INIT_CONTRACT = 1;
     */
    TransactionType[TransactionType["INIT_CONTRACT"] = 1] = "INIT_CONTRACT";
    /**
     * @generated from protobuf enum value: UPDATE = 2;
     */
    TransactionType[TransactionType["UPDATE"] = 2] = "UPDATE";
    /**
     * @generated from protobuf enum value: TRANSFER = 3;
     */
    TransactionType[TransactionType["TRANSFER"] = 3] = "TRANSFER";
    /**
     * @generated from protobuf enum value: ADD_BAKER = 4;
     */
    TransactionType[TransactionType["ADD_BAKER"] = 4] = "ADD_BAKER";
    /**
     * @generated from protobuf enum value: REMOVE_BAKER = 5;
     */
    TransactionType[TransactionType["REMOVE_BAKER"] = 5] = "REMOVE_BAKER";
    /**
     * @generated from protobuf enum value: UPDATE_BAKER_STAKE = 6;
     */
    TransactionType[TransactionType["UPDATE_BAKER_STAKE"] = 6] = "UPDATE_BAKER_STAKE";
    /**
     * @generated from protobuf enum value: UPDATE_BAKER_RESTAKE_EARNINGS = 7;
     */
    TransactionType[TransactionType["UPDATE_BAKER_RESTAKE_EARNINGS"] = 7] = "UPDATE_BAKER_RESTAKE_EARNINGS";
    /**
     * @generated from protobuf enum value: UPDATE_BAKER_KEYS = 8;
     */
    TransactionType[TransactionType["UPDATE_BAKER_KEYS"] = 8] = "UPDATE_BAKER_KEYS";
    /**
     * @generated from protobuf enum value: UPDATE_CREDENTIAL_KEYS = 9;
     */
    TransactionType[TransactionType["UPDATE_CREDENTIAL_KEYS"] = 9] = "UPDATE_CREDENTIAL_KEYS";
    /**
     * @generated from protobuf enum value: ENCRYPTED_AMOUNT_TRANSFER = 10;
     */
    TransactionType[TransactionType["ENCRYPTED_AMOUNT_TRANSFER"] = 10] = "ENCRYPTED_AMOUNT_TRANSFER";
    /**
     * @generated from protobuf enum value: TRANSFER_TO_ENCRYPTED = 11;
     */
    TransactionType[TransactionType["TRANSFER_TO_ENCRYPTED"] = 11] = "TRANSFER_TO_ENCRYPTED";
    /**
     * @generated from protobuf enum value: TRANSFER_TO_PUBLIC = 12;
     */
    TransactionType[TransactionType["TRANSFER_TO_PUBLIC"] = 12] = "TRANSFER_TO_PUBLIC";
    /**
     * @generated from protobuf enum value: TRANSFER_WITH_SCHEDULE = 13;
     */
    TransactionType[TransactionType["TRANSFER_WITH_SCHEDULE"] = 13] = "TRANSFER_WITH_SCHEDULE";
    /**
     * @generated from protobuf enum value: UPDATE_CREDENTIALS = 14;
     */
    TransactionType[TransactionType["UPDATE_CREDENTIALS"] = 14] = "UPDATE_CREDENTIALS";
    /**
     * @generated from protobuf enum value: REGISTER_DATA = 15;
     */
    TransactionType[TransactionType["REGISTER_DATA"] = 15] = "REGISTER_DATA";
    /**
     * @generated from protobuf enum value: TRANSFER_WITH_MEMO = 16;
     */
    TransactionType[TransactionType["TRANSFER_WITH_MEMO"] = 16] = "TRANSFER_WITH_MEMO";
    /**
     * @generated from protobuf enum value: ENCRYPTED_AMOUNT_TRANSFER_WITH_MEMO = 17;
     */
    TransactionType[TransactionType["ENCRYPTED_AMOUNT_TRANSFER_WITH_MEMO"] = 17] = "ENCRYPTED_AMOUNT_TRANSFER_WITH_MEMO";
    /**
     * @generated from protobuf enum value: TRANSFER_WITH_SCHEDULE_AND_MEMO = 18;
     */
    TransactionType[TransactionType["TRANSFER_WITH_SCHEDULE_AND_MEMO"] = 18] = "TRANSFER_WITH_SCHEDULE_AND_MEMO";
    /**
     * @generated from protobuf enum value: CONFIGURE_BAKER = 19;
     */
    TransactionType[TransactionType["CONFIGURE_BAKER"] = 19] = "CONFIGURE_BAKER";
    /**
     * @generated from protobuf enum value: CONFIGURE_DELEGATION = 20;
     */
    TransactionType[TransactionType["CONFIGURE_DELEGATION"] = 20] = "CONFIGURE_DELEGATION";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
/**
 * The different versions of the protocol.
 *
 * @generated from protobuf enum concordium.v2.ProtocolVersion
 */
var ProtocolVersion;
(function (ProtocolVersion) {
    /**
     * @generated from protobuf enum value: PROTOCOL_VERSION_1 = 0;
     */
    ProtocolVersion[ProtocolVersion["PROTOCOL_VERSION_1"] = 0] = "PROTOCOL_VERSION_1";
    /**
     * @generated from protobuf enum value: PROTOCOL_VERSION_2 = 1;
     */
    ProtocolVersion[ProtocolVersion["PROTOCOL_VERSION_2"] = 1] = "PROTOCOL_VERSION_2";
    /**
     * @generated from protobuf enum value: PROTOCOL_VERSION_3 = 2;
     */
    ProtocolVersion[ProtocolVersion["PROTOCOL_VERSION_3"] = 2] = "PROTOCOL_VERSION_3";
    /**
     * @generated from protobuf enum value: PROTOCOL_VERSION_4 = 3;
     */
    ProtocolVersion[ProtocolVersion["PROTOCOL_VERSION_4"] = 3] = "PROTOCOL_VERSION_4";
    /**
     * @generated from protobuf enum value: PROTOCOL_VERSION_5 = 4;
     */
    ProtocolVersion[ProtocolVersion["PROTOCOL_VERSION_5"] = 4] = "PROTOCOL_VERSION_5";
    /**
     * @generated from protobuf enum value: PROTOCOL_VERSION_6 = 5;
     */
    ProtocolVersion[ProtocolVersion["PROTOCOL_VERSION_6"] = 5] = "PROTOCOL_VERSION_6";
})(ProtocolVersion = exports.ProtocolVersion || (exports.ProtocolVersion = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Empty$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Empty", []);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Empty
 */
exports.Empty = new Empty$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockHash$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockHash", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockHash
 */
exports.BlockHash = new BlockHash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sha256Hash$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Sha256Hash", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Sha256Hash
 */
exports.Sha256Hash = new Sha256Hash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionHash$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TransactionHash", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TransactionHash
 */
exports.TransactionHash = new TransactionHash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StateHash$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.StateHash", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.StateHash
 */
exports.StateHash = new StateHash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AbsoluteBlockHeight$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AbsoluteBlockHeight", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AbsoluteBlockHeight
 */
exports.AbsoluteBlockHeight = new AbsoluteBlockHeight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockHeight$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockHeight", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockHeight
 */
exports.BlockHeight = new BlockHeight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerId$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerId", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerId
 */
exports.BakerId = new BakerId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountIndex$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountIndex", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountIndex
 */
exports.AccountIndex = new AccountIndex$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleRef$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ModuleRef", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ModuleRef
 */
exports.ModuleRef = new ModuleRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionedModuleSource$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.VersionedModuleSource", [
            { no: 1, name: "v0", kind: "message", oneof: "module", T: () => exports.VersionedModuleSource_ModuleSourceV0 },
            { no: 2, name: "v1", kind: "message", oneof: "module", T: () => exports.VersionedModuleSource_ModuleSourceV1 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.VersionedModuleSource
 */
exports.VersionedModuleSource = new VersionedModuleSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionedModuleSource_ModuleSourceV0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.VersionedModuleSource.ModuleSourceV0", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.VersionedModuleSource.ModuleSourceV0
 */
exports.VersionedModuleSource_ModuleSourceV0 = new VersionedModuleSource_ModuleSourceV0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionedModuleSource_ModuleSourceV1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.VersionedModuleSource.ModuleSourceV1", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.VersionedModuleSource.ModuleSourceV1
 */
exports.VersionedModuleSource_ModuleSourceV1 = new VersionedModuleSource_ModuleSourceV1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Timestamp$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Timestamp", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Timestamp
 */
exports.Timestamp = new Timestamp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Release$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Release", [
            { no: 1, name: "timestamp", kind: "message", T: () => exports.Timestamp },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 3, name: "transactions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.TransactionHash }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Release
 */
exports.Release = new Release$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewRelease$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NewRelease", [
            { no: 1, name: "timestamp", kind: "message", T: () => exports.Timestamp },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NewRelease
 */
exports.NewRelease = new NewRelease$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReleaseSchedule$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ReleaseSchedule", [
            { no: 1, name: "total", kind: "message", T: () => exports.Amount },
            { no: 2, name: "schedules", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.Release }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ReleaseSchedule
 */
exports.ReleaseSchedule = new ReleaseSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedAmount$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EncryptedAmount", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EncryptedAmount
 */
exports.EncryptedAmount = new EncryptedAmount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedBalance$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EncryptedBalance", [
            { no: 1, name: "self_amount", kind: "message", T: () => exports.EncryptedAmount },
            { no: 2, name: "start_index", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "aggregated_amount", kind: "message", T: () => exports.EncryptedAmount },
            { no: 4, name: "num_aggregated", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "incoming_amounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.EncryptedAmount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EncryptedBalance
 */
exports.EncryptedBalance = new EncryptedBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegationTarget$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegationTarget", [
            { no: 1, name: "passive", kind: "message", oneof: "target", T: () => exports.Empty },
            { no: 2, name: "baker", kind: "message", oneof: "target", T: () => exports.BakerId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegationTarget
 */
exports.DelegationTarget = new DelegationTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerElectionVerifyKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerElectionVerifyKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerElectionVerifyKey
 */
exports.BakerElectionVerifyKey = new BakerElectionVerifyKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerSignatureVerifyKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerSignatureVerifyKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerSignatureVerifyKey
 */
exports.BakerSignatureVerifyKey = new BakerSignatureVerifyKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerAggregationVerifyKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerAggregationVerifyKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerAggregationVerifyKey
 */
exports.BakerAggregationVerifyKey = new BakerAggregationVerifyKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerInfo", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "election_key", kind: "message", T: () => exports.BakerElectionVerifyKey },
            { no: 3, name: "signature_key", kind: "message", T: () => exports.BakerSignatureVerifyKey },
            { no: 4, name: "aggregation_key", kind: "message", T: () => exports.BakerAggregationVerifyKey }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerInfo
 */
exports.BakerInfo = new BakerInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StakePendingChange$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.StakePendingChange", [
            { no: 1, name: "reduce", kind: "message", oneof: "change", T: () => exports.StakePendingChange_Reduce },
            { no: 2, name: "remove", kind: "message", oneof: "change", T: () => exports.Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.StakePendingChange
 */
exports.StakePendingChange = new StakePendingChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StakePendingChange_Reduce$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.StakePendingChange.Reduce", [
            { no: 1, name: "new_stake", kind: "message", T: () => exports.Amount },
            { no: 2, name: "effective_time", kind: "message", T: () => exports.Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.StakePendingChange.Reduce
 */
exports.StakePendingChange_Reduce = new StakePendingChange_Reduce$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AmountFraction$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AmountFraction", [
            { no: 1, name: "parts_per_hundred_thousand", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AmountFraction
 */
exports.AmountFraction = new AmountFraction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommissionRates$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CommissionRates", [
            { no: 1, name: "finalization", kind: "message", T: () => exports.AmountFraction },
            { no: 2, name: "baking", kind: "message", T: () => exports.AmountFraction },
            { no: 3, name: "transaction", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CommissionRates
 */
exports.CommissionRates = new CommissionRates$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerPoolInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerPoolInfo", [
            { no: 1, name: "open_status", kind: "enum", T: () => ["concordium.v2.OpenStatus", OpenStatus, "OPEN_STATUS_"] },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commission_rates", kind: "message", T: () => exports.CommissionRates }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerPoolInfo
 */
exports.BakerPoolInfo = new BakerPoolInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountStakingInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountStakingInfo", [
            { no: 1, name: "baker", kind: "message", oneof: "stakingInfo", T: () => exports.AccountStakingInfo_Baker },
            { no: 2, name: "delegator", kind: "message", oneof: "stakingInfo", T: () => exports.AccountStakingInfo_Delegator }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountStakingInfo
 */
exports.AccountStakingInfo = new AccountStakingInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountStakingInfo_Baker$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountStakingInfo.Baker", [
            { no: 1, name: "staked_amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "restake_earnings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "baker_info", kind: "message", T: () => exports.BakerInfo },
            { no: 4, name: "pending_change", kind: "message", T: () => exports.StakePendingChange },
            { no: 5, name: "pool_info", kind: "message", T: () => exports.BakerPoolInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountStakingInfo.Baker
 */
exports.AccountStakingInfo_Baker = new AccountStakingInfo_Baker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountStakingInfo_Delegator$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountStakingInfo.Delegator", [
            { no: 1, name: "staked_amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "restake_earnings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "target", kind: "message", T: () => exports.DelegationTarget },
            { no: 4, name: "pending_change", kind: "message", T: () => exports.StakePendingChange }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountStakingInfo.Delegator
 */
exports.AccountStakingInfo_Delegator = new AccountStakingInfo_Delegator$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SequenceNumber$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.SequenceNumber", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.SequenceNumber
 */
exports.SequenceNumber = new SequenceNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSequenceNumber$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateSequenceNumber", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateSequenceNumber
 */
exports.UpdateSequenceNumber = new UpdateSequenceNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Amount$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Amount", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Amount
 */
exports.Amount = new Amount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialIndex$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CredentialIndex", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CredentialIndex
 */
exports.CredentialIndex = new CredentialIndex$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignatureThreshold$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.SignatureThreshold", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.SignatureThreshold
 */
exports.SignatureThreshold = new SignatureThreshold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountThreshold$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountThreshold", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountThreshold
 */
exports.AccountThreshold = new AccountThreshold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptionKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EncryptionKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EncryptionKey
 */
exports.EncryptionKey = new EncryptionKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountAddress$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountAddress", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountAddress
 */
exports.AccountAddress = new AccountAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Address$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Address", [
            { no: 1, name: "account", kind: "message", oneof: "type", T: () => exports.AccountAddress },
            { no: 2, name: "contract", kind: "message", oneof: "type", T: () => exports.ContractAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Address
 */
exports.Address = new Address$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountVerifyKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountVerifyKey", [
            { no: 1, name: "ed25519_key", kind: "scalar", oneof: "key", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountVerifyKey
 */
exports.AccountVerifyKey = new AccountVerifyKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialPublicKeys$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CredentialPublicKeys", [
            { no: 1, name: "keys", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.AccountVerifyKey } },
            { no: 2, name: "threshold", kind: "message", T: () => exports.SignatureThreshold }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CredentialPublicKeys
 */
exports.CredentialPublicKeys = new CredentialPublicKeys$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialRegistrationId$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CredentialRegistrationId", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CredentialRegistrationId
 */
exports.CredentialRegistrationId = new CredentialRegistrationId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IdentityProviderIdentity$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IdentityProviderIdentity", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IdentityProviderIdentity
 */
exports.IdentityProviderIdentity = new IdentityProviderIdentity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class YearMonth$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.YearMonth", [
            { no: 1, name: "year", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "month", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.YearMonth
 */
exports.YearMonth = new YearMonth$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Policy$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Policy", [
            { no: 1, name: "created_at", kind: "message", T: () => exports.YearMonth },
            { no: 2, name: "valid_to", kind: "message", T: () => exports.YearMonth },
            { no: 3, name: "attributes", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "scalar", T: 12 /*ScalarType.BYTES*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Policy
 */
exports.Policy = new Policy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitialCredentialValues$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InitialCredentialValues", [
            { no: 1, name: "keys", kind: "message", T: () => exports.CredentialPublicKeys },
            { no: 2, name: "cred_id", kind: "message", T: () => exports.CredentialRegistrationId },
            { no: 3, name: "ip_id", kind: "message", T: () => exports.IdentityProviderIdentity },
            { no: 4, name: "policy", kind: "message", T: () => exports.Policy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InitialCredentialValues
 */
exports.InitialCredentialValues = new InitialCredentialValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChainArData$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ChainArData", [
            { no: 1, name: "enc_id_cred_pub_share", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ChainArData
 */
exports.ChainArData = new ChainArData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArThreshold$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ArThreshold", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ArThreshold
 */
exports.ArThreshold = new ArThreshold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Commitment$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Commitment", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Commitment
 */
exports.Commitment = new Commitment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialCommitments$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CredentialCommitments", [
            { no: 1, name: "prf", kind: "message", T: () => exports.Commitment },
            { no: 2, name: "cred_counter", kind: "message", T: () => exports.Commitment },
            { no: 3, name: "max_accounts", kind: "message", T: () => exports.Commitment },
            { no: 4, name: "attributes", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.Commitment } },
            { no: 5, name: "id_cred_sec_sharing_coeff", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.Commitment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CredentialCommitments
 */
exports.CredentialCommitments = new CredentialCommitments$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NormalCredentialValues$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NormalCredentialValues", [
            { no: 1, name: "keys", kind: "message", T: () => exports.CredentialPublicKeys },
            { no: 2, name: "cred_id", kind: "message", T: () => exports.CredentialRegistrationId },
            { no: 3, name: "ip_id", kind: "message", T: () => exports.IdentityProviderIdentity },
            { no: 4, name: "policy", kind: "message", T: () => exports.Policy },
            { no: 5, name: "ar_threshold", kind: "message", T: () => exports.ArThreshold },
            { no: 6, name: "ar_data", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.ChainArData } },
            { no: 7, name: "commitments", kind: "message", T: () => exports.CredentialCommitments }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NormalCredentialValues
 */
exports.NormalCredentialValues = new NormalCredentialValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountCredential$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountCredential", [
            { no: 1, name: "initial", kind: "message", oneof: "credentialValues", T: () => exports.InitialCredentialValues },
            { no: 2, name: "normal", kind: "message", oneof: "credentialValues", T: () => exports.NormalCredentialValues }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountCredential
 */
exports.AccountCredential = new AccountCredential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountInfo", [
            { no: 1, name: "sequence_number", kind: "message", T: () => exports.SequenceNumber },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 3, name: "schedule", kind: "message", T: () => exports.ReleaseSchedule },
            { no: 4, name: "creds", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.AccountCredential } },
            { no: 5, name: "threshold", kind: "message", T: () => exports.AccountThreshold },
            { no: 6, name: "encrypted_balance", kind: "message", T: () => exports.EncryptedBalance },
            { no: 7, name: "encryption_key", kind: "message", T: () => exports.EncryptionKey },
            { no: 8, name: "index", kind: "message", T: () => exports.AccountIndex },
            { no: 9, name: "stake", kind: "message", T: () => exports.AccountStakingInfo },
            { no: 10, name: "address", kind: "message", T: () => exports.AccountAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountInfo
 */
exports.AccountInfo = new AccountInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockHashInput$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockHashInput", [
            { no: 1, name: "best", kind: "message", oneof: "blockHashInput", T: () => exports.Empty },
            { no: 2, name: "last_final", kind: "message", oneof: "blockHashInput", T: () => exports.Empty },
            { no: 3, name: "given", kind: "message", oneof: "blockHashInput", T: () => exports.BlockHash },
            { no: 4, name: "absolute_height", kind: "message", oneof: "blockHashInput", T: () => exports.AbsoluteBlockHeight },
            { no: 5, name: "relative_height", kind: "message", oneof: "blockHashInput", T: () => exports.BlockHashInput_RelativeHeight }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockHashInput
 */
exports.BlockHashInput = new BlockHashInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockHashInput_RelativeHeight$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockHashInput.RelativeHeight", [
            { no: 1, name: "genesis_index", kind: "message", T: () => exports.GenesisIndex },
            { no: 2, name: "height", kind: "message", T: () => exports.BlockHeight },
            { no: 3, name: "restrict", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockHashInput.RelativeHeight
 */
exports.BlockHashInput_RelativeHeight = new BlockHashInput_RelativeHeight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EpochRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EpochRequest", [
            { no: 1, name: "relative_epoch", kind: "message", oneof: "epochRequestInput", T: () => exports.EpochRequest_RelativeEpoch },
            { no: 2, name: "block_hash", kind: "message", oneof: "epochRequestInput", T: () => exports.BlockHashInput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EpochRequest
 */
exports.EpochRequest = new EpochRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EpochRequest_RelativeEpoch$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EpochRequest.RelativeEpoch", [
            { no: 1, name: "genesis_index", kind: "message", T: () => exports.GenesisIndex },
            { no: 2, name: "epoch", kind: "message", T: () => exports.Epoch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EpochRequest.RelativeEpoch
 */
exports.EpochRequest_RelativeEpoch = new EpochRequest_RelativeEpoch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountIdentifierInput$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountIdentifierInput", [
            { no: 1, name: "address", kind: "message", oneof: "accountIdentifierInput", T: () => exports.AccountAddress },
            { no: 2, name: "cred_id", kind: "message", oneof: "accountIdentifierInput", T: () => exports.CredentialRegistrationId },
            { no: 3, name: "account_index", kind: "message", oneof: "accountIdentifierInput", T: () => exports.AccountIndex }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountIdentifierInput
 */
exports.AccountIdentifierInput = new AccountIdentifierInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInfoRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountInfoRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "account_identifier", kind: "message", T: () => exports.AccountIdentifierInput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountInfoRequest
 */
exports.AccountInfoRequest = new AccountInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizedBlockInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.FinalizedBlockInfo", [
            { no: 1, name: "hash", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "height", kind: "message", T: () => exports.AbsoluteBlockHeight }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.FinalizedBlockInfo
 */
exports.FinalizedBlockInfo = new FinalizedBlockInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AncestorsRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AncestorsRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "amount", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AncestorsRequest
 */
exports.AncestorsRequest = new AncestorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleSourceRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ModuleSourceRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "module_ref", kind: "message", T: () => exports.ModuleRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ModuleSourceRequest
 */
exports.ModuleSourceRequest = new ModuleSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractAddress$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractAddress", [
            { no: 1, name: "index", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "subindex", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractAddress
 */
exports.ContractAddress = new ContractAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceInfoRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceInfoRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "address", kind: "message", T: () => exports.ContractAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceInfoRequest
 */
exports.InstanceInfoRequest = new InstanceInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceInfo", [
            { no: 1, name: "v0", kind: "message", oneof: "version", T: () => exports.InstanceInfo_V0 },
            { no: 2, name: "v1", kind: "message", oneof: "version", T: () => exports.InstanceInfo_V1 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceInfo
 */
exports.InstanceInfo = new InstanceInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceInfo_V0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceInfo.V0", [
            { no: 1, name: "model", kind: "message", T: () => exports.ContractStateV0 },
            { no: 2, name: "owner", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 4, name: "methods", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ReceiveName },
            { no: 5, name: "name", kind: "message", T: () => exports.InitName },
            { no: 6, name: "source_module", kind: "message", T: () => exports.ModuleRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceInfo.V0
 */
exports.InstanceInfo_V0 = new InstanceInfo_V0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceInfo_V1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceInfo.V1", [
            { no: 2, name: "owner", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 4, name: "methods", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ReceiveName },
            { no: 5, name: "name", kind: "message", T: () => exports.InitName },
            { no: 6, name: "source_module", kind: "message", T: () => exports.ModuleRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceInfo.V1
 */
exports.InstanceInfo_V1 = new InstanceInfo_V1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceStateKVPair$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceStateKVPair", [
            { no: 1, name: "key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceStateKVPair
 */
exports.InstanceStateKVPair = new InstanceStateKVPair$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceStateLookupRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceStateLookupRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 3, name: "key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceStateLookupRequest
 */
exports.InstanceStateLookupRequest = new InstanceStateLookupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceStateValueAtKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceStateValueAtKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceStateValueAtKey
 */
exports.InstanceStateValueAtKey = new InstanceStateValueAtKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReceiveName$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ReceiveName", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ReceiveName
 */
exports.ReceiveName = new ReceiveName$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitName$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InitName", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InitName
 */
exports.InitName = new InitName$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Parameter$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Parameter", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Parameter
 */
exports.Parameter = new Parameter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractStateV0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractStateV0", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractStateV0
 */
exports.ContractStateV0 = new ContractStateV0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItemStatus$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItemStatus", [
            { no: 1, name: "received", kind: "message", oneof: "status", T: () => exports.Empty },
            { no: 2, name: "committed", kind: "message", oneof: "status", T: () => exports.BlockItemStatus_Committed },
            { no: 3, name: "finalized", kind: "message", oneof: "status", T: () => exports.BlockItemStatus_Finalized }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItemStatus
 */
exports.BlockItemStatus = new BlockItemStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItemStatus_Committed$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItemStatus.Committed", [
            { no: 1, name: "outcomes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BlockItemSummaryInBlock }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItemStatus.Committed
 */
exports.BlockItemStatus_Committed = new BlockItemStatus_Committed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItemStatus_Finalized$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItemStatus.Finalized", [
            { no: 1, name: "outcome", kind: "message", T: () => exports.BlockItemSummaryInBlock }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItemStatus.Finalized
 */
exports.BlockItemStatus_Finalized = new BlockItemStatus_Finalized$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItemSummaryInBlock$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItemSummaryInBlock", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "outcome", kind: "message", T: () => exports.BlockItemSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItemSummaryInBlock
 */
exports.BlockItemSummaryInBlock = new BlockItemSummaryInBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Energy$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Energy", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Energy
 */
exports.Energy = new Energy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Slot$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Slot", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Slot
 */
exports.Slot = new Slot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NextAccountSequenceNumber$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NextAccountSequenceNumber", [
            { no: 1, name: "sequence_number", kind: "message", T: () => exports.SequenceNumber },
            { no: 2, name: "all_final", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NextAccountSequenceNumber
 */
exports.NextAccountSequenceNumber = new NextAccountSequenceNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Duration$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Duration", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Duration
 */
exports.Duration = new Duration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason", [
            { no: 1, name: "module_not_wf", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 2, name: "module_hash_already_exists", kind: "message", oneof: "reason", T: () => exports.ModuleRef },
            { no: 3, name: "invalid_account_reference", kind: "message", oneof: "reason", T: () => exports.AccountAddress },
            { no: 4, name: "invalid_init_method", kind: "message", oneof: "reason", T: () => exports.RejectReason_InvalidInitMethod },
            { no: 5, name: "invalid_receive_method", kind: "message", oneof: "reason", T: () => exports.RejectReason_InvalidReceiveMethod },
            { no: 6, name: "invalid_module_reference", kind: "message", oneof: "reason", T: () => exports.ModuleRef },
            { no: 7, name: "invalid_contract_address", kind: "message", oneof: "reason", T: () => exports.ContractAddress },
            { no: 8, name: "runtime_failure", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 9, name: "amount_too_large", kind: "message", oneof: "reason", T: () => exports.RejectReason_AmountTooLarge },
            { no: 10, name: "serialization_failure", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 11, name: "out_of_energy", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 12, name: "rejected_init", kind: "message", oneof: "reason", T: () => exports.RejectReason_RejectedInit },
            { no: 13, name: "rejected_receive", kind: "message", oneof: "reason", T: () => exports.RejectReason_RejectedReceive },
            { no: 14, name: "invalid_proof", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 15, name: "already_a_baker", kind: "message", oneof: "reason", T: () => exports.BakerId },
            { no: 16, name: "not_a_baker", kind: "message", oneof: "reason", T: () => exports.AccountAddress },
            { no: 17, name: "insufficient_balance_for_baker_stake", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 18, name: "stake_under_minimum_threshold_for_baking", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 19, name: "baker_in_cooldown", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 20, name: "duplicate_aggregation_key", kind: "message", oneof: "reason", T: () => exports.BakerAggregationVerifyKey },
            { no: 21, name: "non_existent_credential_id", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 22, name: "key_index_already_in_use", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 23, name: "invalid_account_threshold", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 24, name: "invalid_credential_key_sign_threshold", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 25, name: "invalid_encrypted_amount_transfer_proof", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 26, name: "invalid_transfer_to_public_proof", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 27, name: "encrypted_amount_self_transfer", kind: "message", oneof: "reason", T: () => exports.AccountAddress },
            { no: 28, name: "invalid_index_on_encrypted_transfer", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 29, name: "zero_scheduledAmount", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 30, name: "non_increasing_schedule", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 31, name: "first_scheduled_release_expired", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 32, name: "scheduled_self_transfer", kind: "message", oneof: "reason", T: () => exports.AccountAddress },
            { no: 33, name: "invalid_credentials", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 34, name: "duplicate_cred_ids", kind: "message", oneof: "reason", T: () => exports.RejectReason_DuplicateCredIds },
            { no: 35, name: "non_existent_cred_ids", kind: "message", oneof: "reason", T: () => exports.RejectReason_NonExistentCredIds },
            { no: 36, name: "remove_first_credential", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 37, name: "credential_holder_did_not_sign", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 38, name: "not_allowed_multiple_credentials", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 39, name: "not_allowed_to_receive_encrypted", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 40, name: "not_allowed_to_handle_encrypted", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 41, name: "missing_baker_add_parameters", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 42, name: "finalization_reward_commission_not_in_range", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 43, name: "baking_reward_commission_not_in_range", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 44, name: "transaction_fee_commission_not_in_range", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 45, name: "already_a_delegator", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 46, name: "insufficient_balance_for_delegation_stake", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 47, name: "missing_delegation_add_parameters", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 48, name: "insufficient_delegation_stake", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 49, name: "delegator_in_cooldown", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 50, name: "not_a_delegator", kind: "message", oneof: "reason", T: () => exports.AccountAddress },
            { no: 51, name: "delegation_target_not_a_baker", kind: "message", oneof: "reason", T: () => exports.BakerId },
            { no: 52, name: "stake_over_maximum_threshold_for_pool", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 53, name: "pool_would_become_over_delegated", kind: "message", oneof: "reason", T: () => exports.Empty },
            { no: 54, name: "pool_closed", kind: "message", oneof: "reason", T: () => exports.Empty }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason
 */
exports.RejectReason = new RejectReason$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_InvalidInitMethod$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.InvalidInitMethod", [
            { no: 1, name: "module_ref", kind: "message", T: () => exports.ModuleRef },
            { no: 2, name: "init_name", kind: "message", T: () => exports.InitName }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.InvalidInitMethod
 */
exports.RejectReason_InvalidInitMethod = new RejectReason_InvalidInitMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_InvalidReceiveMethod$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.InvalidReceiveMethod", [
            { no: 1, name: "module_ref", kind: "message", T: () => exports.ModuleRef },
            { no: 2, name: "receive_name", kind: "message", T: () => exports.ReceiveName }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.InvalidReceiveMethod
 */
exports.RejectReason_InvalidReceiveMethod = new RejectReason_InvalidReceiveMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_AmountTooLarge$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.AmountTooLarge", [
            { no: 1, name: "address", kind: "message", T: () => exports.Address },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.AmountTooLarge
 */
exports.RejectReason_AmountTooLarge = new RejectReason_AmountTooLarge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_RejectedInit$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.RejectedInit", [
            { no: 1, name: "reject_reason", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.RejectedInit
 */
exports.RejectReason_RejectedInit = new RejectReason_RejectedInit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_RejectedReceive$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.RejectedReceive", [
            { no: 1, name: "reject_reason", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "contract_address", kind: "message", T: () => exports.ContractAddress },
            { no: 3, name: "receive_name", kind: "message", T: () => exports.ReceiveName },
            { no: 4, name: "parameter", kind: "message", T: () => exports.Parameter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.RejectedReceive
 */
exports.RejectReason_RejectedReceive = new RejectReason_RejectedReceive$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_DuplicateCredIds$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.DuplicateCredIds", [
            { no: 1, name: "ids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.CredentialRegistrationId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.DuplicateCredIds
 */
exports.RejectReason_DuplicateCredIds = new RejectReason_DuplicateCredIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectReason_NonExistentCredIds$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RejectReason.NonExistentCredIds", [
            { no: 1, name: "ids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.CredentialRegistrationId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RejectReason.NonExistentCredIds
 */
exports.RejectReason_NonExistentCredIds = new RejectReason_NonExistentCredIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractInitializedEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractInitializedEvent", [
            { no: 1, name: "contract_version", kind: "enum", T: () => ["concordium.v2.ContractVersion", ContractVersion] },
            { no: 2, name: "origin_ref", kind: "message", T: () => exports.ModuleRef },
            { no: 3, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 4, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 5, name: "init_name", kind: "message", T: () => exports.InitName },
            { no: 6, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ContractEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractInitializedEvent
 */
exports.ContractInitializedEvent = new ContractInitializedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractEvent", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractEvent
 */
exports.ContractEvent = new ContractEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstanceUpdatedEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InstanceUpdatedEvent", [
            { no: 1, name: "contract_version", kind: "enum", T: () => ["concordium.v2.ContractVersion", ContractVersion] },
            { no: 2, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 3, name: "instigator", kind: "message", T: () => exports.Address },
            { no: 4, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 5, name: "parameter", kind: "message", T: () => exports.Parameter },
            { no: 6, name: "receive_name", kind: "message", T: () => exports.ReceiveName },
            { no: 7, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ContractEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InstanceUpdatedEvent
 */
exports.InstanceUpdatedEvent = new InstanceUpdatedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractTraceElement$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractTraceElement", [
            { no: 1, name: "updated", kind: "message", oneof: "element", T: () => exports.InstanceUpdatedEvent },
            { no: 2, name: "transferred", kind: "message", oneof: "element", T: () => exports.ContractTraceElement_Transferred },
            { no: 3, name: "interrupted", kind: "message", oneof: "element", T: () => exports.ContractTraceElement_Interrupted },
            { no: 4, name: "resumed", kind: "message", oneof: "element", T: () => exports.ContractTraceElement_Resumed },
            { no: 5, name: "upgraded", kind: "message", oneof: "element", T: () => exports.ContractTraceElement_Upgraded }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractTraceElement
 */
exports.ContractTraceElement = new ContractTraceElement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractTraceElement_Transferred$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractTraceElement.Transferred", [
            { no: 1, name: "sender", kind: "message", T: () => exports.ContractAddress },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 3, name: "receiver", kind: "message", T: () => exports.AccountAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractTraceElement.Transferred
 */
exports.ContractTraceElement_Transferred = new ContractTraceElement_Transferred$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractTraceElement_Interrupted$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractTraceElement.Interrupted", [
            { no: 1, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 2, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ContractEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractTraceElement.Interrupted
 */
exports.ContractTraceElement_Interrupted = new ContractTraceElement_Interrupted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractTraceElement_Resumed$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractTraceElement.Resumed", [
            { no: 1, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractTraceElement.Resumed
 */
exports.ContractTraceElement_Resumed = new ContractTraceElement_Resumed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractTraceElement_Upgraded$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ContractTraceElement.Upgraded", [
            { no: 1, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 2, name: "from", kind: "message", T: () => exports.ModuleRef },
            { no: 3, name: "to", kind: "message", T: () => exports.ModuleRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ContractTraceElement.Upgraded
 */
exports.ContractTraceElement_Upgraded = new ContractTraceElement_Upgraded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerKeysEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerKeysEvent", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "sign_key", kind: "message", T: () => exports.BakerSignatureVerifyKey },
            { no: 4, name: "election_key", kind: "message", T: () => exports.BakerElectionVerifyKey },
            { no: 5, name: "aggregation_key", kind: "message", T: () => exports.BakerAggregationVerifyKey }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerKeysEvent
 */
exports.BakerKeysEvent = new BakerKeysEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Memo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Memo", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Memo
 */
exports.Memo = new Memo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerStakeUpdatedData$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerStakeUpdatedData", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "new_stake", kind: "message", T: () => exports.Amount },
            { no: 3, name: "increased", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerStakeUpdatedData
 */
exports.BakerStakeUpdatedData = new BakerStakeUpdatedData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedAmountRemovedEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EncryptedAmountRemovedEvent", [
            { no: 1, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "new_amount", kind: "message", T: () => exports.EncryptedAmount },
            { no: 3, name: "input_amount", kind: "message", T: () => exports.EncryptedAmount },
            { no: 4, name: "up_to_index", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EncryptedAmountRemovedEvent
 */
exports.EncryptedAmountRemovedEvent = new EncryptedAmountRemovedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewEncryptedAmountEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NewEncryptedAmountEvent", [
            { no: 1, name: "receiver", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "new_index", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "encrypted_amount", kind: "message", T: () => exports.EncryptedAmount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NewEncryptedAmountEvent
 */
exports.NewEncryptedAmountEvent = new NewEncryptedAmountEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedSelfAmountAddedEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EncryptedSelfAmountAddedEvent", [
            { no: 1, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "new_amount", kind: "message", T: () => exports.EncryptedAmount },
            { no: 3, name: "amount", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EncryptedSelfAmountAddedEvent
 */
exports.EncryptedSelfAmountAddedEvent = new EncryptedSelfAmountAddedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisteredData$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RegisteredData", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RegisteredData
 */
exports.RegisteredData = new RegisteredData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent", [
            { no: 1, name: "baker_added", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerAdded },
            { no: 2, name: "baker_removed", kind: "message", oneof: "event", T: () => exports.BakerId },
            { no: 3, name: "baker_stake_increased", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerStakeIncreased },
            { no: 4, name: "baker_stake_decreased", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerStakeDecreased },
            { no: 5, name: "baker_restake_earnings_updated", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerRestakeEarningsUpdated },
            { no: 6, name: "baker_keys_updated", kind: "message", oneof: "event", T: () => exports.BakerKeysEvent },
            { no: 7, name: "baker_set_open_status", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerSetOpenStatus },
            { no: 8, name: "baker_set_metadata_url", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerSetMetadataUrl },
            { no: 9, name: "baker_set_transaction_fee_commission", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerSetTransactionFeeCommission },
            { no: 10, name: "baker_set_baking_reward_commission", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerSetBakingRewardCommission },
            { no: 11, name: "baker_set_finalization_reward_commission", kind: "message", oneof: "event", T: () => exports.BakerEvent_BakerSetFinalizationRewardCommission }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent
 */
exports.BakerEvent = new BakerEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerAdded$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerAdded", [
            { no: 1, name: "keys_event", kind: "message", T: () => exports.BakerKeysEvent },
            { no: 2, name: "stake", kind: "message", T: () => exports.Amount },
            { no: 3, name: "restake_earnings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerAdded
 */
exports.BakerEvent_BakerAdded = new BakerEvent_BakerAdded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerStakeIncreased$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerStakeIncreased", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "new_stake", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerStakeIncreased
 */
exports.BakerEvent_BakerStakeIncreased = new BakerEvent_BakerStakeIncreased$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerStakeDecreased$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerStakeDecreased", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "new_stake", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerStakeDecreased
 */
exports.BakerEvent_BakerStakeDecreased = new BakerEvent_BakerStakeDecreased$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerRestakeEarningsUpdated$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerRestakeEarningsUpdated", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "restake_earnings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerRestakeEarningsUpdated
 */
exports.BakerEvent_BakerRestakeEarningsUpdated = new BakerEvent_BakerRestakeEarningsUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerSetOpenStatus$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerSetOpenStatus", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "open_status", kind: "enum", T: () => ["concordium.v2.OpenStatus", OpenStatus, "OPEN_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerSetOpenStatus
 */
exports.BakerEvent_BakerSetOpenStatus = new BakerEvent_BakerSetOpenStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerSetMetadataUrl$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerSetMetadataUrl", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerSetMetadataUrl
 */
exports.BakerEvent_BakerSetMetadataUrl = new BakerEvent_BakerSetMetadataUrl$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerSetTransactionFeeCommission$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerSetTransactionFeeCommission", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "transaction_fee_commission", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerSetTransactionFeeCommission
 */
exports.BakerEvent_BakerSetTransactionFeeCommission = new BakerEvent_BakerSetTransactionFeeCommission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerSetBakingRewardCommission$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerSetBakingRewardCommission", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "baking_reward_commission", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerSetBakingRewardCommission
 */
exports.BakerEvent_BakerSetBakingRewardCommission = new BakerEvent_BakerSetBakingRewardCommission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerEvent_BakerSetFinalizationRewardCommission$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerEvent.BakerSetFinalizationRewardCommission", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "finalization_reward_commission", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerEvent.BakerSetFinalizationRewardCommission
 */
exports.BakerEvent_BakerSetFinalizationRewardCommission = new BakerEvent_BakerSetFinalizationRewardCommission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegatorId$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegatorId", [
            { no: 1, name: "id", kind: "message", T: () => exports.AccountIndex }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegatorId
 */
exports.DelegatorId = new DelegatorId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegationEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegationEvent", [
            { no: 1, name: "delegation_stake_increased", kind: "message", oneof: "event", T: () => exports.DelegationEvent_DelegationStakeIncreased },
            { no: 2, name: "delegation_stake_decreased", kind: "message", oneof: "event", T: () => exports.DelegationEvent_DelegationStakeDecreased },
            { no: 3, name: "delegation_set_restake_earnings", kind: "message", oneof: "event", T: () => exports.DelegationEvent_DelegationSetRestakeEarnings },
            { no: 4, name: "delegation_set_delegation_target", kind: "message", oneof: "event", T: () => exports.DelegationEvent_DelegationSetDelegationTarget },
            { no: 5, name: "delegation_added", kind: "message", oneof: "event", T: () => exports.DelegatorId },
            { no: 6, name: "delegation_removed", kind: "message", oneof: "event", T: () => exports.DelegatorId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegationEvent
 */
exports.DelegationEvent = new DelegationEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegationEvent_DelegationStakeIncreased$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegationEvent.DelegationStakeIncreased", [
            { no: 1, name: "delegator_id", kind: "message", T: () => exports.DelegatorId },
            { no: 2, name: "new_stake", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegationEvent.DelegationStakeIncreased
 */
exports.DelegationEvent_DelegationStakeIncreased = new DelegationEvent_DelegationStakeIncreased$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegationEvent_DelegationStakeDecreased$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegationEvent.DelegationStakeDecreased", [
            { no: 1, name: "delegator_id", kind: "message", T: () => exports.DelegatorId },
            { no: 2, name: "new_stake", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegationEvent.DelegationStakeDecreased
 */
exports.DelegationEvent_DelegationStakeDecreased = new DelegationEvent_DelegationStakeDecreased$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegationEvent_DelegationSetRestakeEarnings$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegationEvent.DelegationSetRestakeEarnings", [
            { no: 1, name: "delegator_id", kind: "message", T: () => exports.DelegatorId },
            { no: 2, name: "restake_earnings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegationEvent.DelegationSetRestakeEarnings
 */
exports.DelegationEvent_DelegationSetRestakeEarnings = new DelegationEvent_DelegationSetRestakeEarnings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegationEvent_DelegationSetDelegationTarget$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegationEvent.DelegationSetDelegationTarget", [
            { no: 1, name: "delegator_id", kind: "message", T: () => exports.DelegatorId },
            { no: 2, name: "delegation_target", kind: "message", T: () => exports.DelegationTarget }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegationEvent.DelegationSetDelegationTarget
 */
exports.DelegationEvent_DelegationSetDelegationTarget = new DelegationEvent_DelegationSetDelegationTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects", [
            { no: 1, name: "none", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_None },
            { no: 2, name: "module_deployed", kind: "message", oneof: "effect", T: () => exports.ModuleRef },
            { no: 3, name: "contract_initialized", kind: "message", oneof: "effect", T: () => exports.ContractInitializedEvent },
            { no: 4, name: "contract_update_issued", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_ContractUpdateIssued },
            { no: 5, name: "account_transfer", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_AccountTransfer },
            { no: 6, name: "baker_added", kind: "message", oneof: "effect", T: () => exports.BakerEvent_BakerAdded },
            { no: 7, name: "baker_removed", kind: "message", oneof: "effect", T: () => exports.BakerId },
            { no: 8, name: "baker_stake_updated", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_BakerStakeUpdated },
            { no: 9, name: "baker_restake_earnings_updated", kind: "message", oneof: "effect", T: () => exports.BakerEvent_BakerRestakeEarningsUpdated },
            { no: 10, name: "baker_keys_updated", kind: "message", oneof: "effect", T: () => exports.BakerKeysEvent },
            { no: 11, name: "encrypted_amount_transferred", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_EncryptedAmountTransferred },
            { no: 12, name: "transferred_to_encrypted", kind: "message", oneof: "effect", T: () => exports.EncryptedSelfAmountAddedEvent },
            { no: 13, name: "transferred_to_public", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_TransferredToPublic },
            { no: 14, name: "transferred_with_schedule", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_TransferredWithSchedule },
            { no: 15, name: "credential_keys_updated", kind: "message", oneof: "effect", T: () => exports.CredentialRegistrationId },
            { no: 16, name: "credentials_updated", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_CredentialsUpdated },
            { no: 17, name: "data_registered", kind: "message", oneof: "effect", T: () => exports.RegisteredData },
            { no: 18, name: "baker_configured", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_BakerConfigured },
            { no: 19, name: "delegation_configured", kind: "message", oneof: "effect", T: () => exports.AccountTransactionEffects_DelegationConfigured }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects
 */
exports.AccountTransactionEffects = new AccountTransactionEffects$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_None$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.None", [
            { no: 1, name: "transaction_type", kind: "enum", opt: true, T: () => ["concordium.v2.TransactionType", TransactionType] },
            { no: 2, name: "reject_reason", kind: "message", T: () => exports.RejectReason }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.None
 */
exports.AccountTransactionEffects_None = new AccountTransactionEffects_None$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_ContractUpdateIssued$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.ContractUpdateIssued", [
            { no: 1, name: "effects", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ContractTraceElement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.ContractUpdateIssued
 */
exports.AccountTransactionEffects_ContractUpdateIssued = new AccountTransactionEffects_ContractUpdateIssued$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_AccountTransfer$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.AccountTransfer", [
            { no: 1, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "receiver", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "memo", kind: "message", T: () => exports.Memo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.AccountTransfer
 */
exports.AccountTransactionEffects_AccountTransfer = new AccountTransactionEffects_AccountTransfer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_BakerStakeUpdated$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.BakerStakeUpdated", [
            { no: 1, name: "update", kind: "message", T: () => exports.BakerStakeUpdatedData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.BakerStakeUpdated
 */
exports.AccountTransactionEffects_BakerStakeUpdated = new AccountTransactionEffects_BakerStakeUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_EncryptedAmountTransferred$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.EncryptedAmountTransferred", [
            { no: 1, name: "removed", kind: "message", T: () => exports.EncryptedAmountRemovedEvent },
            { no: 2, name: "added", kind: "message", T: () => exports.NewEncryptedAmountEvent },
            { no: 3, name: "memo", kind: "message", T: () => exports.Memo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.EncryptedAmountTransferred
 */
exports.AccountTransactionEffects_EncryptedAmountTransferred = new AccountTransactionEffects_EncryptedAmountTransferred$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_TransferredToPublic$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.TransferredToPublic", [
            { no: 1, name: "removed", kind: "message", T: () => exports.EncryptedAmountRemovedEvent },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.TransferredToPublic
 */
exports.AccountTransactionEffects_TransferredToPublic = new AccountTransactionEffects_TransferredToPublic$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_TransferredWithSchedule$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.TransferredWithSchedule", [
            { no: 1, name: "receiver", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "amount", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.NewRelease },
            { no: 3, name: "memo", kind: "message", T: () => exports.Memo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.TransferredWithSchedule
 */
exports.AccountTransactionEffects_TransferredWithSchedule = new AccountTransactionEffects_TransferredWithSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_CredentialsUpdated$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.CredentialsUpdated", [
            { no: 1, name: "new_cred_ids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.CredentialRegistrationId },
            { no: 2, name: "removed_cred_ids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.CredentialRegistrationId },
            { no: 3, name: "new_threshold", kind: "message", T: () => exports.AccountThreshold }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.CredentialsUpdated
 */
exports.AccountTransactionEffects_CredentialsUpdated = new AccountTransactionEffects_CredentialsUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_BakerConfigured$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.BakerConfigured", [
            { no: 1, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BakerEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.BakerConfigured
 */
exports.AccountTransactionEffects_BakerConfigured = new AccountTransactionEffects_BakerConfigured$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionEffects_DelegationConfigured$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionEffects.DelegationConfigured", [
            { no: 1, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.DelegationEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionEffects.DelegationConfigured
 */
exports.AccountTransactionEffects_DelegationConfigured = new AccountTransactionEffects_DelegationConfigured$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ElectionDifficulty$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ElectionDifficulty", [
            { no: 1, name: "value", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ElectionDifficulty
 */
exports.ElectionDifficulty = new ElectionDifficulty$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoutParameters$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TimeoutParameters", [
            { no: 1, name: "timeout_base", kind: "message", T: () => exports.Duration },
            { no: 2, name: "timeout_increase", kind: "message", T: () => exports.Ratio },
            { no: 3, name: "timeout_decrease", kind: "message", T: () => exports.Ratio }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TimeoutParameters
 */
exports.TimeoutParameters = new TimeoutParameters$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizationCommitteeParameters$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.FinalizationCommitteeParameters", [
            { no: 1, name: "minimum_finalizers", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "maximum_finalizers", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "finalizer_relative_stake_threshold", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.FinalizationCommitteeParameters
 */
exports.FinalizationCommitteeParameters = new FinalizationCommitteeParameters$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsensusParametersV1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ConsensusParametersV1", [
            { no: 1, name: "timeout_parameters", kind: "message", T: () => exports.TimeoutParameters },
            { no: 2, name: "min_block_time", kind: "message", T: () => exports.Duration },
            { no: 3, name: "block_energy_limit", kind: "message", T: () => exports.Energy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ConsensusParametersV1
 */
exports.ConsensusParametersV1 = new ConsensusParametersV1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExchangeRate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ExchangeRate", [
            { no: 1, name: "value", kind: "message", T: () => exports.Ratio }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ExchangeRate
 */
exports.ExchangeRate = new ExchangeRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Ratio$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Ratio", [
            { no: 1, name: "numerator", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "denominator", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Ratio
 */
exports.Ratio = new Ratio$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePublicKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdatePublicKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdatePublicKey
 */
exports.UpdatePublicKey = new UpdatePublicKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateKeysThreshold$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateKeysThreshold", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateKeysThreshold
 */
exports.UpdateKeysThreshold = new UpdateKeysThreshold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateKeysIndex$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateKeysIndex", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateKeysIndex
 */
exports.UpdateKeysIndex = new UpdateKeysIndex$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HigherLevelKeys$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.HigherLevelKeys", [
            { no: 1, name: "keys", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.UpdatePublicKey },
            { no: 2, name: "threshold", kind: "message", T: () => exports.UpdateKeysThreshold }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.HigherLevelKeys
 */
exports.HigherLevelKeys = new HigherLevelKeys$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessStructure$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccessStructure", [
            { no: 1, name: "access_public_keys", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.UpdateKeysIndex },
            { no: 2, name: "access_threshold", kind: "message", T: () => exports.UpdateKeysThreshold }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccessStructure
 */
exports.AccessStructure = new AccessStructure$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizationsV0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AuthorizationsV0", [
            { no: 1, name: "keys", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.UpdatePublicKey },
            { no: 2, name: "emergency", kind: "message", T: () => exports.AccessStructure },
            { no: 3, name: "protocol", kind: "message", T: () => exports.AccessStructure },
            { no: 4, name: "parameter_consensus", kind: "message", T: () => exports.AccessStructure },
            { no: 5, name: "parameter_euro_per_energy", kind: "message", T: () => exports.AccessStructure },
            { no: 6, name: "parameter_micro_CCD_per_euro", kind: "message", T: () => exports.AccessStructure },
            { no: 7, name: "parameter_foundation_account", kind: "message", T: () => exports.AccessStructure },
            { no: 8, name: "parameter_mint_distribution", kind: "message", T: () => exports.AccessStructure },
            { no: 9, name: "parameter_transaction_fee_distribution", kind: "message", T: () => exports.AccessStructure },
            { no: 10, name: "parameter_gas_rewards", kind: "message", T: () => exports.AccessStructure },
            { no: 11, name: "pool_parameters", kind: "message", T: () => exports.AccessStructure },
            { no: 12, name: "add_anonymity_revoker", kind: "message", T: () => exports.AccessStructure },
            { no: 13, name: "add_identity_provider", kind: "message", T: () => exports.AccessStructure }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AuthorizationsV0
 */
exports.AuthorizationsV0 = new AuthorizationsV0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizationsV1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AuthorizationsV1", [
            { no: 1, name: "v0", kind: "message", T: () => exports.AuthorizationsV0 },
            { no: 2, name: "parameter_cooldown", kind: "message", T: () => exports.AccessStructure },
            { no: 3, name: "parameter_time", kind: "message", T: () => exports.AccessStructure }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AuthorizationsV1
 */
exports.AuthorizationsV1 = new AuthorizationsV1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Description$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Description", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Description
 */
exports.Description = new Description$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ArInfo", [
            { no: 1, name: "identity", kind: "message", T: () => exports.ArInfo_ArIdentity },
            { no: 2, name: "description", kind: "message", T: () => exports.Description },
            { no: 3, name: "public_key", kind: "message", T: () => exports.ArInfo_ArPublicKey }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ArInfo
 */
exports.ArInfo = new ArInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArInfo_ArIdentity$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ArInfo.ArIdentity", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ArInfo.ArIdentity
 */
exports.ArInfo_ArIdentity = new ArInfo_ArIdentity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArInfo_ArPublicKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ArInfo.ArPublicKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ArInfo.ArPublicKey
 */
exports.ArInfo_ArPublicKey = new ArInfo_ArPublicKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IpIdentity$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IpIdentity", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IpIdentity
 */
exports.IpIdentity = new IpIdentity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IpInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IpInfo", [
            { no: 1, name: "identity", kind: "message", T: () => exports.IpIdentity },
            { no: 2, name: "description", kind: "message", T: () => exports.Description },
            { no: 3, name: "verify_key", kind: "message", T: () => exports.IpInfo_IpVerifyKey },
            { no: 4, name: "cdi_verify_key", kind: "message", T: () => exports.IpInfo_IpCdiVerifyKey }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IpInfo
 */
exports.IpInfo = new IpInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IpInfo_IpVerifyKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IpInfo.IpVerifyKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IpInfo.IpVerifyKey
 */
exports.IpInfo_IpVerifyKey = new IpInfo_IpVerifyKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IpInfo_IpCdiVerifyKey$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IpInfo.IpCdiVerifyKey", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IpInfo.IpCdiVerifyKey
 */
exports.IpInfo_IpCdiVerifyKey = new IpInfo_IpCdiVerifyKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DurationSeconds$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DurationSeconds", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DurationSeconds
 */
exports.DurationSeconds = new DurationSeconds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InclusiveRangeAmountFraction$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InclusiveRangeAmountFraction", [
            { no: 1, name: "min", kind: "message", T: () => exports.AmountFraction },
            { no: 2, name: "max_", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InclusiveRangeAmountFraction
 */
exports.InclusiveRangeAmountFraction = new InclusiveRangeAmountFraction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommissionRanges$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CommissionRanges", [
            { no: 1, name: "finalization", kind: "message", T: () => exports.InclusiveRangeAmountFraction },
            { no: 2, name: "baking", kind: "message", T: () => exports.InclusiveRangeAmountFraction },
            { no: 3, name: "transaction", kind: "message", T: () => exports.InclusiveRangeAmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CommissionRanges
 */
exports.CommissionRanges = new CommissionRanges$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CapitalBound$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CapitalBound", [
            { no: 1, name: "value", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CapitalBound
 */
exports.CapitalBound = new CapitalBound$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeverageFactor$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.LeverageFactor", [
            { no: 1, name: "value", kind: "message", T: () => exports.Ratio }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.LeverageFactor
 */
exports.LeverageFactor = new LeverageFactor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Epoch$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Epoch", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Epoch
 */
exports.Epoch = new Epoch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Round$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Round", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Round
 */
exports.Round = new Round$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RewardPeriodLength$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RewardPeriodLength", [
            { no: 1, name: "value", kind: "message", T: () => exports.Epoch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RewardPeriodLength
 */
exports.RewardPeriodLength = new RewardPeriodLength$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MintRate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.MintRate", [
            { no: 1, name: "mantissa", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "exponent", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.MintRate
 */
exports.MintRate = new MintRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CooldownParametersCpv1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CooldownParametersCpv1", [
            { no: 1, name: "pool_owner_cooldown", kind: "message", T: () => exports.DurationSeconds },
            { no: 2, name: "delegator_cooldown", kind: "message", T: () => exports.DurationSeconds }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CooldownParametersCpv1
 */
exports.CooldownParametersCpv1 = new CooldownParametersCpv1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolParametersCpv1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolParametersCpv1", [
            { no: 1, name: "passive_finalization_commission", kind: "message", T: () => exports.AmountFraction },
            { no: 2, name: "passive_baking_commission", kind: "message", T: () => exports.AmountFraction },
            { no: 3, name: "passive_transaction_commission", kind: "message", T: () => exports.AmountFraction },
            { no: 4, name: "commission_bounds", kind: "message", T: () => exports.CommissionRanges },
            { no: 5, name: "minimum_equity_capital", kind: "message", T: () => exports.Amount },
            { no: 6, name: "capital_bound", kind: "message", T: () => exports.CapitalBound },
            { no: 7, name: "leverage_bound", kind: "message", T: () => exports.LeverageFactor }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolParametersCpv1
 */
exports.PoolParametersCpv1 = new PoolParametersCpv1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeParametersCpv1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TimeParametersCpv1", [
            { no: 1, name: "reward_period_length", kind: "message", T: () => exports.RewardPeriodLength },
            { no: 2, name: "mint_per_payday", kind: "message", T: () => exports.MintRate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TimeParametersCpv1
 */
exports.TimeParametersCpv1 = new TimeParametersCpv1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MintDistributionCpv1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.MintDistributionCpv1", [
            { no: 1, name: "baking_reward", kind: "message", T: () => exports.AmountFraction },
            { no: 2, name: "finalization_reward", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.MintDistributionCpv1
 */
exports.MintDistributionCpv1 = new MintDistributionCpv1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProtocolUpdate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ProtocolUpdate", [
            { no: 1, name: "message_", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "specification_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "specificationHash", kind: "message", T: () => exports.Sha256Hash },
            { no: 4, name: "specification_auxiliary_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ProtocolUpdate
 */
exports.ProtocolUpdate = new ProtocolUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MintDistributionCpv0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.MintDistributionCpv0", [
            { no: 1, name: "mint_per_slot", kind: "message", T: () => exports.MintRate },
            { no: 2, name: "baking_reward", kind: "message", T: () => exports.AmountFraction },
            { no: 3, name: "finalization_reward", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.MintDistributionCpv0
 */
exports.MintDistributionCpv0 = new MintDistributionCpv0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionFeeDistribution$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TransactionFeeDistribution", [
            { no: 1, name: "baker", kind: "message", T: () => exports.AmountFraction },
            { no: 2, name: "gas_account", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TransactionFeeDistribution
 */
exports.TransactionFeeDistribution = new TransactionFeeDistribution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GasRewards$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.GasRewards", [
            { no: 1, name: "baker", kind: "message", T: () => exports.AmountFraction },
            { no: 2, name: "finalization_proof", kind: "message", T: () => exports.AmountFraction },
            { no: 3, name: "account_creation", kind: "message", T: () => exports.AmountFraction },
            { no: 4, name: "chain_update", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.GasRewards
 */
exports.GasRewards = new GasRewards$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GasRewardsCpv2$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.GasRewardsCpv2", [
            { no: 1, name: "baker", kind: "message", T: () => exports.AmountFraction },
            { no: 3, name: "account_creation", kind: "message", T: () => exports.AmountFraction },
            { no: 4, name: "chain_update", kind: "message", T: () => exports.AmountFraction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.GasRewardsCpv2
 */
exports.GasRewardsCpv2 = new GasRewardsCpv2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerStakeThreshold$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerStakeThreshold", [
            { no: 1, name: "baker_stake_threshold", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerStakeThreshold
 */
exports.BakerStakeThreshold = new BakerStakeThreshold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RootUpdate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.RootUpdate", [
            { no: 1, name: "root_keys_update", kind: "message", oneof: "updateType", T: () => exports.HigherLevelKeys },
            { no: 2, name: "level_1_keys_update", kind: "message", oneof: "updateType", T: () => exports.HigherLevelKeys },
            { no: 3, name: "level_2_keys_update_v0", kind: "message", oneof: "updateType", T: () => exports.AuthorizationsV0 },
            { no: 4, name: "level_2_keys_update_v1", kind: "message", oneof: "updateType", T: () => exports.AuthorizationsV1 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.RootUpdate
 */
exports.RootUpdate = new RootUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Level1Update$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Level1Update", [
            { no: 1, name: "level_1_keys_update", kind: "message", oneof: "updateType", T: () => exports.HigherLevelKeys },
            { no: 2, name: "level_2_keys_update_v0", kind: "message", oneof: "updateType", T: () => exports.AuthorizationsV0 },
            { no: 3, name: "level_2_keys_update_v1", kind: "message", oneof: "updateType", T: () => exports.AuthorizationsV1 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Level1Update
 */
exports.Level1Update = new Level1Update$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdatePayload", [
            { no: 1, name: "protocol_update", kind: "message", oneof: "payload", T: () => exports.ProtocolUpdate },
            { no: 2, name: "election_difficulty_update", kind: "message", oneof: "payload", T: () => exports.ElectionDifficulty },
            { no: 3, name: "euro_per_energy_update", kind: "message", oneof: "payload", T: () => exports.ExchangeRate },
            { no: 4, name: "micro_ccd_per_euro_update", kind: "message", oneof: "payload", T: () => exports.ExchangeRate },
            { no: 5, name: "foundation_account_update", kind: "message", oneof: "payload", T: () => exports.AccountAddress },
            { no: 6, name: "mint_distribution_update", kind: "message", oneof: "payload", T: () => exports.MintDistributionCpv0 },
            { no: 7, name: "transaction_fee_distribution_update", kind: "message", oneof: "payload", T: () => exports.TransactionFeeDistribution },
            { no: 8, name: "gas_rewards_update", kind: "message", oneof: "payload", T: () => exports.GasRewards },
            { no: 9, name: "baker_stake_threshold_update", kind: "message", oneof: "payload", T: () => exports.BakerStakeThreshold },
            { no: 10, name: "root_update", kind: "message", oneof: "payload", T: () => exports.RootUpdate },
            { no: 11, name: "level_1_update", kind: "message", oneof: "payload", T: () => exports.Level1Update },
            { no: 12, name: "add_anonymity_revoker_update", kind: "message", oneof: "payload", T: () => exports.ArInfo },
            { no: 13, name: "add_identity_provider_update", kind: "message", oneof: "payload", T: () => exports.IpInfo },
            { no: 14, name: "cooldown_parameters_cpv_1_update", kind: "message", oneof: "payload", T: () => exports.CooldownParametersCpv1 },
            { no: 15, name: "pool_parameters_cpv_1_update", kind: "message", oneof: "payload", T: () => exports.PoolParametersCpv1 },
            { no: 16, name: "time_parameters_cpv_1_update", kind: "message", oneof: "payload", T: () => exports.TimeParametersCpv1 },
            { no: 17, name: "mint_distribution_cpv_1_update", kind: "message", oneof: "payload", T: () => exports.MintDistributionCpv1 },
            { no: 18, name: "gas_rewards_cpv_2_update", kind: "message", oneof: "payload", T: () => exports.GasRewardsCpv2 },
            { no: 19, name: "timeout_parameters_update", kind: "message", oneof: "payload", T: () => exports.TimeoutParameters },
            { no: 20, name: "min_block_time_update", kind: "message", oneof: "payload", T: () => exports.Duration },
            { no: 21, name: "block_energy_limit_update", kind: "message", oneof: "payload", T: () => exports.Energy },
            { no: 22, name: "finalization_committee_parameters_update", kind: "message", oneof: "payload", T: () => exports.FinalizationCommitteeParameters }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdatePayload
 */
exports.UpdatePayload = new UpdatePayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionDetails$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionDetails", [
            { no: 1, name: "cost", kind: "message", T: () => exports.Amount },
            { no: 2, name: "sender", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "effects", kind: "message", T: () => exports.AccountTransactionEffects }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionDetails
 */
exports.AccountTransactionDetails = new AccountTransactionDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountCreationDetails$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountCreationDetails", [
            { no: 1, name: "credential_type", kind: "enum", T: () => ["concordium.v2.CredentialType", CredentialType, "CREDENTIAL_TYPE_"] },
            { no: 2, name: "address", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "reg_id", kind: "message", T: () => exports.CredentialRegistrationId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountCreationDetails
 */
exports.AccountCreationDetails = new AccountCreationDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionTime$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TransactionTime", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TransactionTime
 */
exports.TransactionTime = new TransactionTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDetails$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateDetails", [
            { no: 1, name: "effective_time", kind: "message", T: () => exports.TransactionTime },
            { no: 2, name: "payload", kind: "message", T: () => exports.UpdatePayload }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateDetails
 */
exports.UpdateDetails = new UpdateDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItemSummary$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItemSummary", [
            { no: 1, name: "index", kind: "message", T: () => exports.BlockItemSummary_TransactionIndex },
            { no: 2, name: "energy_cost", kind: "message", T: () => exports.Energy },
            { no: 3, name: "hash", kind: "message", T: () => exports.TransactionHash },
            { no: 4, name: "account_transaction", kind: "message", oneof: "details", T: () => exports.AccountTransactionDetails },
            { no: 5, name: "account_creation", kind: "message", oneof: "details", T: () => exports.AccountCreationDetails },
            { no: 6, name: "update", kind: "message", oneof: "details", T: () => exports.UpdateDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItemSummary
 */
exports.BlockItemSummary = new BlockItemSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItemSummary_TransactionIndex$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItemSummary.TransactionIndex", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItemSummary.TransactionIndex
 */
exports.BlockItemSummary_TransactionIndex = new BlockItemSummary_TransactionIndex$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenesisIndex$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.GenesisIndex", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.GenesisIndex
 */
exports.GenesisIndex = new GenesisIndex$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsensusInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ConsensusInfo", [
            { no: 1, name: "best_block", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "genesis_block", kind: "message", T: () => exports.BlockHash },
            { no: 3, name: "genesis_time", kind: "message", T: () => exports.Timestamp },
            { no: 4, name: "slot_duration", kind: "message", T: () => exports.Duration },
            { no: 5, name: "epoch_duration", kind: "message", T: () => exports.Duration },
            { no: 6, name: "last_finalized_block", kind: "message", T: () => exports.BlockHash },
            { no: 7, name: "best_block_height", kind: "message", T: () => exports.AbsoluteBlockHeight },
            { no: 8, name: "last_finalized_block_height", kind: "message", T: () => exports.AbsoluteBlockHeight },
            { no: 9, name: "blocks_received_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "block_last_received_time", kind: "message", T: () => exports.Timestamp },
            { no: 11, name: "block_receive_latency_ema", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "block_receive_latency_emsd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "block_receive_period_ema", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "block_receive_period_emsd", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "blocks_verified_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 16, name: "block_last_arrived_time", kind: "message", T: () => exports.Timestamp },
            { no: 17, name: "block_arrive_latency_ema", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 18, name: "block_arrive_latency_emsd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 19, name: "block_arrive_period_ema", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 20, name: "block_arrive_period_emsd", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 21, name: "transactions_per_block_ema", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 22, name: "transactions_per_block_emsd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 23, name: "finalization_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 24, name: "last_finalized_time", kind: "message", T: () => exports.Timestamp },
            { no: 25, name: "finalization_period_ema", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 26, name: "finalization_period_emsd", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 27, name: "protocol_version", kind: "enum", T: () => ["concordium.v2.ProtocolVersion", ProtocolVersion] },
            { no: 28, name: "genesis_index", kind: "message", T: () => exports.GenesisIndex },
            { no: 29, name: "current_era_genesis_block", kind: "message", T: () => exports.BlockHash },
            { no: 30, name: "current_era_genesis_time", kind: "message", T: () => exports.Timestamp },
            { no: 31, name: "current_timeout_duration", kind: "message", T: () => exports.Duration },
            { no: 32, name: "current_round", kind: "message", T: () => exports.Round },
            { no: 33, name: "current_epoch", kind: "message", T: () => exports.Epoch },
            { no: 34, name: "trigger_block_time", kind: "message", T: () => exports.Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ConsensusInfo
 */
exports.ConsensusInfo = new ConsensusInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArrivedBlockInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ArrivedBlockInfo", [
            { no: 1, name: "hash", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "height", kind: "message", T: () => exports.AbsoluteBlockHeight }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ArrivedBlockInfo
 */
exports.ArrivedBlockInfo = new ArrivedBlockInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CryptographicParameters$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CryptographicParameters", [
            { no: 1, name: "genesis_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bulletproof_generators", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "on_chain_commitment_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CryptographicParameters
 */
exports.CryptographicParameters = new CryptographicParameters$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockInfo", [
            { no: 1, name: "hash", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "height", kind: "message", T: () => exports.AbsoluteBlockHeight },
            { no: 3, name: "parent_block", kind: "message", T: () => exports.BlockHash },
            { no: 4, name: "last_finalized_block", kind: "message", T: () => exports.BlockHash },
            { no: 5, name: "genesis_index", kind: "message", T: () => exports.GenesisIndex },
            { no: 6, name: "era_block_height", kind: "message", T: () => exports.BlockHeight },
            { no: 7, name: "receive_time", kind: "message", T: () => exports.Timestamp },
            { no: 8, name: "arrive_time", kind: "message", T: () => exports.Timestamp },
            { no: 9, name: "slot_number", kind: "message", T: () => exports.Slot },
            { no: 10, name: "slot_time", kind: "message", T: () => exports.Timestamp },
            { no: 11, name: "baker", kind: "message", T: () => exports.BakerId },
            { no: 12, name: "finalized", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "transaction_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 14, name: "transactions_energy_cost", kind: "message", T: () => exports.Energy },
            { no: 15, name: "transactions_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 16, name: "state_hash", kind: "message", T: () => exports.StateHash },
            { no: 17, name: "protocol_version", kind: "enum", T: () => ["concordium.v2.ProtocolVersion", ProtocolVersion] },
            { no: 18, name: "round", kind: "message", T: () => exports.Round },
            { no: 19, name: "epoch", kind: "message", T: () => exports.Epoch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockInfo
 */
exports.BlockInfo = new BlockInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolInfoRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolInfoRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "baker", kind: "message", T: () => exports.BakerId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolInfoRequest
 */
exports.PoolInfoRequest = new PoolInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolPendingChange$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolPendingChange", [
            { no: 1, name: "reduce", kind: "message", oneof: "change", T: () => exports.PoolPendingChange_Reduce },
            { no: 2, name: "remove", kind: "message", oneof: "change", T: () => exports.PoolPendingChange_Remove }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolPendingChange
 */
exports.PoolPendingChange = new PoolPendingChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolPendingChange_Reduce$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolPendingChange.Reduce", [
            { no: 1, name: "reduced_equity_capital", kind: "message", T: () => exports.Amount },
            { no: 2, name: "effective_time", kind: "message", T: () => exports.Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolPendingChange.Reduce
 */
exports.PoolPendingChange_Reduce = new PoolPendingChange_Reduce$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolPendingChange_Remove$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolPendingChange.Remove", [
            { no: 1, name: "effective_time", kind: "message", T: () => exports.Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolPendingChange.Remove
 */
exports.PoolPendingChange_Remove = new PoolPendingChange_Remove$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolCurrentPaydayInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolCurrentPaydayInfo", [
            { no: 1, name: "blocks_baked", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "finalization_live", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "transaction_fees_earned", kind: "message", T: () => exports.Amount },
            { no: 4, name: "effective_stake", kind: "message", T: () => exports.Amount },
            { no: 5, name: "lottery_power", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "baker_equity_capital", kind: "message", T: () => exports.Amount },
            { no: 7, name: "delegated_capital", kind: "message", T: () => exports.Amount },
            { no: 8, name: "commission_rates", kind: "message", T: () => exports.CommissionRates }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolCurrentPaydayInfo
 */
exports.PoolCurrentPaydayInfo = new PoolCurrentPaydayInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolInfoResponse$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PoolInfoResponse", [
            { no: 1, name: "baker", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "address", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "equity_capital", kind: "message", T: () => exports.Amount },
            { no: 4, name: "delegated_capital", kind: "message", T: () => exports.Amount },
            { no: 5, name: "delegated_capital_cap", kind: "message", T: () => exports.Amount },
            { no: 6, name: "pool_info", kind: "message", T: () => exports.BakerPoolInfo },
            { no: 7, name: "equity_pending_change", kind: "message", T: () => exports.PoolPendingChange },
            { no: 8, name: "current_payday_info", kind: "message", T: () => exports.PoolCurrentPaydayInfo },
            { no: 9, name: "all_pool_total_capital", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PoolInfoResponse
 */
exports.PoolInfoResponse = new PoolInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PassiveDelegationInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PassiveDelegationInfo", [
            { no: 1, name: "delegated_capital", kind: "message", T: () => exports.Amount },
            { no: 2, name: "commission_rates", kind: "message", T: () => exports.CommissionRates },
            { no: 3, name: "current_payday_transaction_fees_earned", kind: "message", T: () => exports.Amount },
            { no: 4, name: "current_payday_delegated_capital", kind: "message", T: () => exports.Amount },
            { no: 5, name: "all_pool_total_capital", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PassiveDelegationInfo
 */
exports.PassiveDelegationInfo = new PassiveDelegationInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlocksAtHeightRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlocksAtHeightRequest", [
            { no: 1, name: "absolute", kind: "message", oneof: "blocksAtHeight", T: () => exports.BlocksAtHeightRequest_Absolute },
            { no: 2, name: "relative", kind: "message", oneof: "blocksAtHeight", T: () => exports.BlocksAtHeightRequest_Relative }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlocksAtHeightRequest
 */
exports.BlocksAtHeightRequest = new BlocksAtHeightRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlocksAtHeightRequest_Absolute$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlocksAtHeightRequest.Absolute", [
            { no: 1, name: "height", kind: "message", T: () => exports.AbsoluteBlockHeight }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlocksAtHeightRequest.Absolute
 */
exports.BlocksAtHeightRequest_Absolute = new BlocksAtHeightRequest_Absolute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlocksAtHeightRequest_Relative$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlocksAtHeightRequest.Relative", [
            { no: 1, name: "genesis_index", kind: "message", T: () => exports.GenesisIndex },
            { no: 2, name: "height", kind: "message", T: () => exports.BlockHeight },
            { no: 3, name: "restrict", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlocksAtHeightRequest.Relative
 */
exports.BlocksAtHeightRequest_Relative = new BlocksAtHeightRequest_Relative$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlocksAtHeightResponse$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlocksAtHeightResponse", [
            { no: 1, name: "blocks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BlockHash }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlocksAtHeightResponse
 */
exports.BlocksAtHeightResponse = new BlocksAtHeightResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenomicsInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TokenomicsInfo", [
            { no: 1, name: "v0", kind: "message", oneof: "tokenomics", T: () => exports.TokenomicsInfo_V0 },
            { no: 2, name: "v1", kind: "message", oneof: "tokenomics", T: () => exports.TokenomicsInfo_V1 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TokenomicsInfo
 */
exports.TokenomicsInfo = new TokenomicsInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenomicsInfo_V0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TokenomicsInfo.V0", [
            { no: 1, name: "total_amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "total_encrypted_amount", kind: "message", T: () => exports.Amount },
            { no: 3, name: "baking_reward_account", kind: "message", T: () => exports.Amount },
            { no: 4, name: "finalization_reward_account", kind: "message", T: () => exports.Amount },
            { no: 5, name: "gas_account", kind: "message", T: () => exports.Amount },
            { no: 6, name: "protocol_version", kind: "enum", T: () => ["concordium.v2.ProtocolVersion", ProtocolVersion] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TokenomicsInfo.V0
 */
exports.TokenomicsInfo_V0 = new TokenomicsInfo_V0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenomicsInfo_V1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TokenomicsInfo.V1", [
            { no: 1, name: "total_amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "total_encrypted_amount", kind: "message", T: () => exports.Amount },
            { no: 3, name: "baking_reward_account", kind: "message", T: () => exports.Amount },
            { no: 4, name: "finalization_reward_account", kind: "message", T: () => exports.Amount },
            { no: 5, name: "gas_account", kind: "message", T: () => exports.Amount },
            { no: 6, name: "foundation_transaction_rewards", kind: "message", T: () => exports.Amount },
            { no: 7, name: "next_payday_time", kind: "message", T: () => exports.Timestamp },
            { no: 8, name: "next_payday_mint_rate", kind: "message", T: () => exports.MintRate },
            { no: 9, name: "total_staked_capital", kind: "message", T: () => exports.Amount },
            { no: 10, name: "protocol_version", kind: "enum", T: () => ["concordium.v2.ProtocolVersion", ProtocolVersion] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TokenomicsInfo.V1
 */
exports.TokenomicsInfo_V1 = new TokenomicsInfo_V1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeInstanceRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InvokeInstanceRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "invoker", kind: "message", T: () => exports.Address },
            { no: 3, name: "instance", kind: "message", T: () => exports.ContractAddress },
            { no: 4, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 5, name: "entrypoint", kind: "message", T: () => exports.ReceiveName },
            { no: 6, name: "parameter", kind: "message", T: () => exports.Parameter },
            { no: 7, name: "energy", kind: "message", T: () => exports.Energy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InvokeInstanceRequest
 */
exports.InvokeInstanceRequest = new InvokeInstanceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeInstanceResponse$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InvokeInstanceResponse", [
            { no: 1, name: "success", kind: "message", oneof: "result", T: () => exports.InvokeInstanceResponse_Success },
            { no: 2, name: "failure", kind: "message", oneof: "result", T: () => exports.InvokeInstanceResponse_Failure }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InvokeInstanceResponse
 */
exports.InvokeInstanceResponse = new InvokeInstanceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeInstanceResponse_Failure$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InvokeInstanceResponse.Failure", [
            { no: 1, name: "return_value", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "used_energy", kind: "message", T: () => exports.Energy },
            { no: 3, name: "reason", kind: "message", T: () => exports.RejectReason }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InvokeInstanceResponse.Failure
 */
exports.InvokeInstanceResponse_Failure = new InvokeInstanceResponse_Failure$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeInstanceResponse_Success$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InvokeInstanceResponse.Success", [
            { no: 1, name: "return_value", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "used_energy", kind: "message", T: () => exports.Energy },
            { no: 3, name: "effects", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ContractTraceElement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InvokeInstanceResponse.Success
 */
exports.InvokeInstanceResponse_Success = new InvokeInstanceResponse_Success$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPoolDelegatorsRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.GetPoolDelegatorsRequest", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHashInput },
            { no: 2, name: "baker", kind: "message", T: () => exports.BakerId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.GetPoolDelegatorsRequest
 */
exports.GetPoolDelegatorsRequest = new GetPoolDelegatorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegatorInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegatorInfo", [
            { no: 1, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "stake", kind: "message", T: () => exports.Amount },
            { no: 3, name: "pending_change", kind: "message", T: () => exports.StakePendingChange }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegatorInfo
 */
exports.DelegatorInfo = new DelegatorInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegatorRewardPeriodInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DelegatorRewardPeriodInfo", [
            { no: 1, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "stake", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DelegatorRewardPeriodInfo
 */
exports.DelegatorRewardPeriodInfo = new DelegatorRewardPeriodInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Branch$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Branch", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "children", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.Branch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Branch
 */
exports.Branch = new Branch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeadershipElectionNonce$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.LeadershipElectionNonce", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.LeadershipElectionNonce
 */
exports.LeadershipElectionNonce = new LeadershipElectionNonce$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ElectionInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ElectionInfo", [
            { no: 1, name: "election_difficulty", kind: "message", T: () => exports.ElectionDifficulty },
            { no: 2, name: "election_nonce", kind: "message", T: () => exports.LeadershipElectionNonce },
            { no: 3, name: "baker_election_info", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.ElectionInfo_Baker }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ElectionInfo
 */
exports.ElectionInfo = new ElectionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ElectionInfo_Baker$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ElectionInfo.Baker", [
            { no: 1, name: "baker", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "lottery_power", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ElectionInfo.Baker
 */
exports.ElectionInfo_Baker = new ElectionInfo_Baker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent", [
            { no: 1, name: "baking_rewards", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_BakingRewards },
            { no: 2, name: "mint", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_Mint },
            { no: 3, name: "finalization_rewards", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_FinalizationRewards },
            { no: 4, name: "block_reward", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_BlockReward },
            { no: 5, name: "payday_foundation_reward", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_PaydayFoundationReward },
            { no: 6, name: "payday_account_reward", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_PaydayAccountReward },
            { no: 7, name: "block_accrue_reward", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_BlockAccrueReward },
            { no: 8, name: "payday_pool_reward", kind: "message", oneof: "event", T: () => exports.BlockSpecialEvent_PaydayPoolReward }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent
 */
exports.BlockSpecialEvent = new BlockSpecialEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_AccountAmounts$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.AccountAmounts", [
            { no: 1, name: "entries", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BlockSpecialEvent_AccountAmounts_Entry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.AccountAmounts
 */
exports.BlockSpecialEvent_AccountAmounts = new BlockSpecialEvent_AccountAmounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_AccountAmounts_Entry$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.AccountAmounts.Entry", [
            { no: 1, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "amount", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.AccountAmounts.Entry
 */
exports.BlockSpecialEvent_AccountAmounts_Entry = new BlockSpecialEvent_AccountAmounts_Entry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_BakingRewards$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.BakingRewards", [
            { no: 1, name: "baker_rewards", kind: "message", T: () => exports.BlockSpecialEvent_AccountAmounts },
            { no: 2, name: "remainder", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.BakingRewards
 */
exports.BlockSpecialEvent_BakingRewards = new BlockSpecialEvent_BakingRewards$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_Mint$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.Mint", [
            { no: 1, name: "mint_baking_reward", kind: "message", T: () => exports.Amount },
            { no: 2, name: "mint_finalization_reward", kind: "message", T: () => exports.Amount },
            { no: 3, name: "mint_platform_development_charge", kind: "message", T: () => exports.Amount },
            { no: 4, name: "foundation_account", kind: "message", T: () => exports.AccountAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.Mint
 */
exports.BlockSpecialEvent_Mint = new BlockSpecialEvent_Mint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_FinalizationRewards$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.FinalizationRewards", [
            { no: 1, name: "finalization_rewards", kind: "message", T: () => exports.BlockSpecialEvent_AccountAmounts },
            { no: 2, name: "remainder", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.FinalizationRewards
 */
exports.BlockSpecialEvent_FinalizationRewards = new BlockSpecialEvent_FinalizationRewards$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_BlockReward$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.BlockReward", [
            { no: 1, name: "transaction_fees", kind: "message", T: () => exports.Amount },
            { no: 2, name: "old_gas_account", kind: "message", T: () => exports.Amount },
            { no: 3, name: "new_gas_account", kind: "message", T: () => exports.Amount },
            { no: 4, name: "baker_reward", kind: "message", T: () => exports.Amount },
            { no: 5, name: "foundation_charge", kind: "message", T: () => exports.Amount },
            { no: 6, name: "baker", kind: "message", T: () => exports.AccountAddress },
            { no: 7, name: "foundation_account", kind: "message", T: () => exports.AccountAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.BlockReward
 */
exports.BlockSpecialEvent_BlockReward = new BlockSpecialEvent_BlockReward$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_PaydayFoundationReward$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.PaydayFoundationReward", [
            { no: 1, name: "foundation_account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "development_charge", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.PaydayFoundationReward
 */
exports.BlockSpecialEvent_PaydayFoundationReward = new BlockSpecialEvent_PaydayFoundationReward$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_PaydayAccountReward$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.PaydayAccountReward", [
            { no: 1, name: "account", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "transaction_fees", kind: "message", T: () => exports.Amount },
            { no: 3, name: "baker_reward", kind: "message", T: () => exports.Amount },
            { no: 4, name: "finalization_reward", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.PaydayAccountReward
 */
exports.BlockSpecialEvent_PaydayAccountReward = new BlockSpecialEvent_PaydayAccountReward$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_BlockAccrueReward$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.BlockAccrueReward", [
            { no: 1, name: "transaction_fees", kind: "message", T: () => exports.Amount },
            { no: 2, name: "old_gas_account", kind: "message", T: () => exports.Amount },
            { no: 3, name: "new_gas_account", kind: "message", T: () => exports.Amount },
            { no: 4, name: "baker_reward", kind: "message", T: () => exports.Amount },
            { no: 5, name: "passive_reward", kind: "message", T: () => exports.Amount },
            { no: 6, name: "foundation_charge", kind: "message", T: () => exports.Amount },
            { no: 7, name: "baker", kind: "message", T: () => exports.BakerId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.BlockAccrueReward
 */
exports.BlockSpecialEvent_BlockAccrueReward = new BlockSpecialEvent_BlockAccrueReward$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSpecialEvent_PaydayPoolReward$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockSpecialEvent.PaydayPoolReward", [
            { no: 1, name: "pool_owner", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "transaction_fees", kind: "message", T: () => exports.Amount },
            { no: 3, name: "baker_reward", kind: "message", T: () => exports.Amount },
            { no: 4, name: "finalization_reward", kind: "message", T: () => exports.Amount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockSpecialEvent.PaydayPoolReward
 */
exports.BlockSpecialEvent_PaydayPoolReward = new BlockSpecialEvent_PaydayPoolReward$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingUpdate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PendingUpdate", [
            { no: 1, name: "effective_time", kind: "message", T: () => exports.TransactionTime },
            { no: 2, name: "root_keys", kind: "message", oneof: "effect", T: () => exports.HigherLevelKeys },
            { no: 3, name: "level1_keys", kind: "message", oneof: "effect", T: () => exports.HigherLevelKeys },
            { no: 4, name: "level2_keys_cpv_0", kind: "message", oneof: "effect", T: () => exports.AuthorizationsV0 },
            { no: 5, name: "level2_keys_cpv_1", kind: "message", oneof: "effect", T: () => exports.AuthorizationsV1 },
            { no: 6, name: "protocol", kind: "message", oneof: "effect", T: () => exports.ProtocolUpdate },
            { no: 7, name: "election_difficulty", kind: "message", oneof: "effect", T: () => exports.ElectionDifficulty },
            { no: 8, name: "euro_per_energy", kind: "message", oneof: "effect", T: () => exports.ExchangeRate },
            { no: 9, name: "micro_ccd_per_euro", kind: "message", oneof: "effect", T: () => exports.ExchangeRate },
            { no: 10, name: "foundation_account", kind: "message", oneof: "effect", T: () => exports.AccountAddress },
            { no: 11, name: "mint_distribution_cpv_0", kind: "message", oneof: "effect", T: () => exports.MintDistributionCpv0 },
            { no: 12, name: "mint_distribution_cpv_1", kind: "message", oneof: "effect", T: () => exports.MintDistributionCpv1 },
            { no: 13, name: "transaction_fee_distribution", kind: "message", oneof: "effect", T: () => exports.TransactionFeeDistribution },
            { no: 14, name: "gas_rewards", kind: "message", oneof: "effect", T: () => exports.GasRewards },
            { no: 15, name: "pool_parameters_cpv_0", kind: "message", oneof: "effect", T: () => exports.BakerStakeThreshold },
            { no: 16, name: "pool_parameters_cpv_1", kind: "message", oneof: "effect", T: () => exports.PoolParametersCpv1 },
            { no: 17, name: "add_anonymity_revoker", kind: "message", oneof: "effect", T: () => exports.ArInfo },
            { no: 18, name: "add_identity_provider", kind: "message", oneof: "effect", T: () => exports.IpInfo },
            { no: 19, name: "cooldown_parameters", kind: "message", oneof: "effect", T: () => exports.CooldownParametersCpv1 },
            { no: 20, name: "time_parameters", kind: "message", oneof: "effect", T: () => exports.TimeParametersCpv1 },
            { no: 21, name: "gas_rewards_cpv_2", kind: "message", oneof: "effect", T: () => exports.GasRewardsCpv2 },
            { no: 22, name: "timeout_parameters", kind: "message", oneof: "effect", T: () => exports.TimeoutParameters },
            { no: 23, name: "min_block_time", kind: "message", oneof: "effect", T: () => exports.Duration },
            { no: 24, name: "block_energy_limit", kind: "message", oneof: "effect", T: () => exports.Energy },
            { no: 25, name: "finalization_committee_parameters", kind: "message", oneof: "effect", T: () => exports.FinalizationCommitteeParameters }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PendingUpdate
 */
exports.PendingUpdate = new PendingUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NextUpdateSequenceNumbers$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NextUpdateSequenceNumbers", [
            { no: 1, name: "root_keys", kind: "message", T: () => exports.SequenceNumber },
            { no: 2, name: "level1_keys", kind: "message", T: () => exports.SequenceNumber },
            { no: 3, name: "level2_keys", kind: "message", T: () => exports.SequenceNumber },
            { no: 4, name: "protocol", kind: "message", T: () => exports.SequenceNumber },
            { no: 5, name: "election_difficulty", kind: "message", T: () => exports.SequenceNumber },
            { no: 6, name: "euro_per_energy", kind: "message", T: () => exports.SequenceNumber },
            { no: 7, name: "micro_ccd_per_euro", kind: "message", T: () => exports.SequenceNumber },
            { no: 8, name: "foundation_account", kind: "message", T: () => exports.SequenceNumber },
            { no: 9, name: "mint_distribution", kind: "message", T: () => exports.SequenceNumber },
            { no: 10, name: "transaction_fee_distribution", kind: "message", T: () => exports.SequenceNumber },
            { no: 11, name: "gas_rewards", kind: "message", T: () => exports.SequenceNumber },
            { no: 12, name: "pool_parameters", kind: "message", T: () => exports.SequenceNumber },
            { no: 13, name: "add_anonymity_revoker", kind: "message", T: () => exports.SequenceNumber },
            { no: 14, name: "add_identity_provider", kind: "message", T: () => exports.SequenceNumber },
            { no: 15, name: "cooldown_parameters", kind: "message", T: () => exports.SequenceNumber },
            { no: 16, name: "time_parameters", kind: "message", T: () => exports.SequenceNumber },
            { no: 17, name: "timeout_parameters", kind: "message", T: () => exports.SequenceNumber },
            { no: 18, name: "min_block_time", kind: "message", T: () => exports.SequenceNumber },
            { no: 19, name: "block_energy_limit", kind: "message", T: () => exports.SequenceNumber },
            { no: 20, name: "finalization_committee_parameters", kind: "message", T: () => exports.SequenceNumber }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NextUpdateSequenceNumbers
 */
exports.NextUpdateSequenceNumbers = new NextUpdateSequenceNumbers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IpAddress$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IpAddress", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IpAddress
 */
exports.IpAddress = new IpAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Port$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Port", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Port
 */
exports.Port = new Port$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IpSocketAddress$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.IpSocketAddress", [
            { no: 1, name: "ip", kind: "message", T: () => exports.IpAddress },
            { no: 2, name: "port", kind: "message", T: () => exports.Port }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.IpSocketAddress
 */
exports.IpSocketAddress = new IpSocketAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerId$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PeerId", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PeerId
 */
exports.PeerId = new PeerId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BannedPeer$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BannedPeer", [
            { no: 1, name: "ip_address", kind: "message", T: () => exports.IpAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BannedPeer
 */
exports.BannedPeer = new BannedPeer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BannedPeers$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BannedPeers", [
            { no: 1, name: "peers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BannedPeer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BannedPeers
 */
exports.BannedPeers = new BannedPeers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerToBan$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PeerToBan", [
            { no: 1, name: "ip_address", kind: "message", T: () => exports.IpAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PeerToBan
 */
exports.PeerToBan = new PeerToBan$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DumpRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.DumpRequest", [
            { no: 1, name: "file", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "raw", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.DumpRequest
 */
exports.DumpRequest = new DumpRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeersInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PeersInfo", [
            { no: 1, name: "peers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.PeersInfo_Peer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PeersInfo
 */
exports.PeersInfo = new PeersInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeersInfo_Peer$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PeersInfo.Peer", [
            { no: 1, name: "peer_id", kind: "message", T: () => exports.PeerId },
            { no: 2, name: "socket_address", kind: "message", T: () => exports.IpSocketAddress },
            { no: 3, name: "network_stats", kind: "message", T: () => exports.PeersInfo_Peer_NetworkStats },
            { no: 4, name: "bootstrapper", kind: "message", oneof: "consensusInfo", T: () => exports.Empty },
            { no: 5, name: "node_catchup_status", kind: "enum", oneof: "consensusInfo", T: () => ["concordium.v2.PeersInfo.Peer.CatchupStatus", PeersInfo_Peer_CatchupStatus] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PeersInfo.Peer
 */
exports.PeersInfo_Peer = new PeersInfo_Peer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeersInfo_Peer_NetworkStats$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PeersInfo.Peer.NetworkStats", [
            { no: 2, name: "packets_sent", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "packets_received", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "latency", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PeersInfo.Peer.NetworkStats
 */
exports.PeersInfo_Peer_NetworkStats = new PeersInfo_Peer_NetworkStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NodeInfo", [
            { no: 1, name: "peer_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "local_time", kind: "message", T: () => exports.Timestamp },
            { no: 4, name: "peer_uptime", kind: "message", T: () => exports.Duration },
            { no: 5, name: "network_info", kind: "message", T: () => exports.NodeInfo_NetworkInfo },
            { no: 6, name: "bootstrapper", kind: "message", oneof: "details", T: () => exports.Empty },
            { no: 7, name: "node", kind: "message", oneof: "details", T: () => exports.NodeInfo_Node }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NodeInfo
 */
exports.NodeInfo = new NodeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeInfo_NetworkInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NodeInfo.NetworkInfo", [
            { no: 1, name: "node_id", kind: "message", T: () => exports.PeerId },
            { no: 2, name: "peer_total_sent", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "peer_total_received", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "avg_bps_in", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "avg_bps_out", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NodeInfo.NetworkInfo
 */
exports.NodeInfo_NetworkInfo = new NodeInfo_NetworkInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeInfo_BakerConsensusInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NodeInfo.BakerConsensusInfo", [
            { no: 1, name: "baker_id", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "passive_committee_info", kind: "enum", oneof: "status", T: () => ["concordium.v2.NodeInfo.BakerConsensusInfo.PassiveCommitteeInfo", NodeInfo_BakerConsensusInfo_PassiveCommitteeInfo] },
            { no: 3, name: "active_baker_committee_info", kind: "message", oneof: "status", T: () => exports.NodeInfo_BakerConsensusInfo_ActiveBakerCommitteeInfo },
            { no: 4, name: "active_finalizer_committee_info", kind: "message", oneof: "status", T: () => exports.NodeInfo_BakerConsensusInfo_ActiveFinalizerCommitteeInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NodeInfo.BakerConsensusInfo
 */
exports.NodeInfo_BakerConsensusInfo = new NodeInfo_BakerConsensusInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeInfo_BakerConsensusInfo_ActiveBakerCommitteeInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NodeInfo.BakerConsensusInfo.ActiveBakerCommitteeInfo", []);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NodeInfo.BakerConsensusInfo.ActiveBakerCommitteeInfo
 */
exports.NodeInfo_BakerConsensusInfo_ActiveBakerCommitteeInfo = new NodeInfo_BakerConsensusInfo_ActiveBakerCommitteeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeInfo_BakerConsensusInfo_ActiveFinalizerCommitteeInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NodeInfo.BakerConsensusInfo.ActiveFinalizerCommitteeInfo", []);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NodeInfo.BakerConsensusInfo.ActiveFinalizerCommitteeInfo
 */
exports.NodeInfo_BakerConsensusInfo_ActiveFinalizerCommitteeInfo = new NodeInfo_BakerConsensusInfo_ActiveFinalizerCommitteeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeInfo_Node$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.NodeInfo.Node", [
            { no: 1, name: "not_running", kind: "message", oneof: "consensusStatus", T: () => exports.Empty },
            { no: 2, name: "passive", kind: "message", oneof: "consensusStatus", T: () => exports.Empty },
            { no: 3, name: "active", kind: "message", oneof: "consensusStatus", T: () => exports.NodeInfo_BakerConsensusInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.NodeInfo.Node
 */
exports.NodeInfo_Node = new NodeInfo_Node$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendBlockItemRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.SendBlockItemRequest", [
            { no: 1, name: "account_transaction", kind: "message", oneof: "blockItem", T: () => exports.AccountTransaction },
            { no: 2, name: "credential_deployment", kind: "message", oneof: "blockItem", T: () => exports.CredentialDeployment },
            { no: 3, name: "update_instruction", kind: "message", oneof: "blockItem", T: () => exports.UpdateInstruction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.SendBlockItemRequest
 */
exports.SendBlockItemRequest = new SendBlockItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDeployment$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CredentialDeployment", [
            { no: 1, name: "message_expiry", kind: "message", T: () => exports.TransactionTime },
            { no: 2, name: "raw_payload", kind: "scalar", oneof: "payload", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CredentialDeployment
 */
exports.CredentialDeployment = new CredentialDeployment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Signature$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.Signature", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.Signature
 */
exports.Signature = new Signature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignatureMap$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.SignatureMap", [
            { no: 1, name: "signatures", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.Signature } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.SignatureMap
 */
exports.SignatureMap = new SignatureMap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountSignatureMap$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountSignatureMap", [
            { no: 1, name: "signatures", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.Signature } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountSignatureMap
 */
exports.AccountSignatureMap = new AccountSignatureMap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionSignature$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionSignature", [
            { no: 1, name: "signatures", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.AccountSignatureMap } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionSignature
 */
exports.AccountTransactionSignature = new AccountTransactionSignature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionHeader$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionHeader", [
            { no: 1, name: "sender", kind: "message", T: () => exports.AccountAddress },
            { no: 2, name: "sequence_number", kind: "message", T: () => exports.SequenceNumber },
            { no: 3, name: "energy_amount", kind: "message", T: () => exports.Energy },
            { no: 5, name: "expiry", kind: "message", T: () => exports.TransactionTime }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionHeader
 */
exports.AccountTransactionHeader = new AccountTransactionHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitContractPayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.InitContractPayload", [
            { no: 1, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "module_ref", kind: "message", T: () => exports.ModuleRef },
            { no: 3, name: "init_name", kind: "message", T: () => exports.InitName },
            { no: 4, name: "parameter", kind: "message", T: () => exports.Parameter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.InitContractPayload
 */
exports.InitContractPayload = new InitContractPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateContractPayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateContractPayload", [
            { no: 1, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "address", kind: "message", T: () => exports.ContractAddress },
            { no: 3, name: "receive_name", kind: "message", T: () => exports.ReceiveName },
            { no: 4, name: "parameter", kind: "message", T: () => exports.Parameter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateContractPayload
 */
exports.UpdateContractPayload = new UpdateContractPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferPayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TransferPayload", [
            { no: 1, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "receiver", kind: "message", T: () => exports.AccountAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TransferPayload
 */
exports.TransferPayload = new TransferPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferWithMemoPayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TransferWithMemoPayload", [
            { no: 1, name: "amount", kind: "message", T: () => exports.Amount },
            { no: 2, name: "receiver", kind: "message", T: () => exports.AccountAddress },
            { no: 3, name: "memo", kind: "message", T: () => exports.Memo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TransferWithMemoPayload
 */
exports.TransferWithMemoPayload = new TransferWithMemoPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionPayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionPayload", [
            { no: 1, name: "raw_payload", kind: "scalar", oneof: "payload", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "deploy_module", kind: "message", oneof: "payload", T: () => exports.VersionedModuleSource },
            { no: 3, name: "init_contract", kind: "message", oneof: "payload", T: () => exports.InitContractPayload },
            { no: 4, name: "update_contract", kind: "message", oneof: "payload", T: () => exports.UpdateContractPayload },
            { no: 5, name: "transfer", kind: "message", oneof: "payload", T: () => exports.TransferPayload },
            { no: 6, name: "transfer_with_memo", kind: "message", oneof: "payload", T: () => exports.TransferWithMemoPayload },
            { no: 7, name: "register_data", kind: "message", oneof: "payload", T: () => exports.RegisteredData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionPayload
 */
exports.AccountTransactionPayload = new AccountTransactionPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreAccountTransaction$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.PreAccountTransaction", [
            { no: 1, name: "header", kind: "message", T: () => exports.AccountTransactionHeader },
            { no: 2, name: "payload", kind: "message", T: () => exports.AccountTransactionPayload }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.PreAccountTransaction
 */
exports.PreAccountTransaction = new PreAccountTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransaction$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransaction", [
            { no: 1, name: "signature", kind: "message", T: () => exports.AccountTransactionSignature },
            { no: 2, name: "header", kind: "message", T: () => exports.AccountTransactionHeader },
            { no: 3, name: "payload", kind: "message", T: () => exports.AccountTransactionPayload }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransaction
 */
exports.AccountTransaction = new AccountTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateInstructionSignature$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateInstructionSignature", [
            { no: 1, name: "signatures", kind: "map", K: 13 /*ScalarType.UINT32*/, V: { kind: "message", T: () => exports.Signature } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateInstructionSignature
 */
exports.UpdateInstructionSignature = new UpdateInstructionSignature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateInstructionHeader$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateInstructionHeader", [
            { no: 1, name: "sequence_number", kind: "message", T: () => exports.UpdateSequenceNumber },
            { no: 2, name: "effective_time", kind: "message", T: () => exports.TransactionTime },
            { no: 3, name: "timeout", kind: "message", T: () => exports.TransactionTime }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateInstructionHeader
 */
exports.UpdateInstructionHeader = new UpdateInstructionHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateInstructionPayload$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateInstructionPayload", [
            { no: 3, name: "raw_payload", kind: "scalar", oneof: "payload", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateInstructionPayload
 */
exports.UpdateInstructionPayload = new UpdateInstructionPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateInstruction$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.UpdateInstruction", [
            { no: 1, name: "signatures", kind: "message", T: () => exports.SignatureMap },
            { no: 2, name: "header", kind: "message", T: () => exports.UpdateInstructionHeader },
            { no: 3, name: "payload", kind: "message", T: () => exports.UpdateInstructionPayload }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.UpdateInstruction
 */
exports.UpdateInstruction = new UpdateInstruction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountTransactionSignHash$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.AccountTransactionSignHash", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.AccountTransactionSignHash
 */
exports.AccountTransactionSignHash = new AccountTransactionSignHash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialsPerBlockLimit$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.CredentialsPerBlockLimit", [
            { no: 1, name: "value", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.CredentialsPerBlockLimit
 */
exports.CredentialsPerBlockLimit = new CredentialsPerBlockLimit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChainParametersV0$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ChainParametersV0", [
            { no: 1, name: "election_difficulty", kind: "message", T: () => exports.ElectionDifficulty },
            { no: 2, name: "euro_per_energy", kind: "message", T: () => exports.ExchangeRate },
            { no: 3, name: "micro_ccd_per_euro", kind: "message", T: () => exports.ExchangeRate },
            { no: 4, name: "baker_cooldown_epochs", kind: "message", T: () => exports.Epoch },
            { no: 5, name: "account_creation_limit", kind: "message", T: () => exports.CredentialsPerBlockLimit },
            { no: 6, name: "mint_distribution", kind: "message", T: () => exports.MintDistributionCpv0 },
            { no: 7, name: "transaction_fee_distribution", kind: "message", T: () => exports.TransactionFeeDistribution },
            { no: 8, name: "gas_rewards", kind: "message", T: () => exports.GasRewards },
            { no: 9, name: "foundation_account", kind: "message", T: () => exports.AccountAddress },
            { no: 10, name: "minimum_threshold_for_baking", kind: "message", T: () => exports.Amount },
            { no: 11, name: "root_keys", kind: "message", T: () => exports.HigherLevelKeys },
            { no: 12, name: "level1_keys", kind: "message", T: () => exports.HigherLevelKeys },
            { no: 13, name: "level2_keys", kind: "message", T: () => exports.AuthorizationsV0 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ChainParametersV0
 */
exports.ChainParametersV0 = new ChainParametersV0$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChainParametersV1$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ChainParametersV1", [
            { no: 1, name: "election_difficulty", kind: "message", T: () => exports.ElectionDifficulty },
            { no: 2, name: "euro_per_energy", kind: "message", T: () => exports.ExchangeRate },
            { no: 3, name: "micro_ccd_per_euro", kind: "message", T: () => exports.ExchangeRate },
            { no: 4, name: "cooldown_parameters", kind: "message", T: () => exports.CooldownParametersCpv1 },
            { no: 5, name: "time_parameters", kind: "message", T: () => exports.TimeParametersCpv1 },
            { no: 6, name: "account_creation_limit", kind: "message", T: () => exports.CredentialsPerBlockLimit },
            { no: 7, name: "mint_distribution", kind: "message", T: () => exports.MintDistributionCpv1 },
            { no: 8, name: "transaction_fee_distribution", kind: "message", T: () => exports.TransactionFeeDistribution },
            { no: 9, name: "gas_rewards", kind: "message", T: () => exports.GasRewards },
            { no: 10, name: "foundation_account", kind: "message", T: () => exports.AccountAddress },
            { no: 11, name: "pool_parameters", kind: "message", T: () => exports.PoolParametersCpv1 },
            { no: 12, name: "root_keys", kind: "message", T: () => exports.HigherLevelKeys },
            { no: 13, name: "level1_keys", kind: "message", T: () => exports.HigherLevelKeys },
            { no: 14, name: "level2_keys", kind: "message", T: () => exports.AuthorizationsV1 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ChainParametersV1
 */
exports.ChainParametersV1 = new ChainParametersV1$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChainParametersV2$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ChainParametersV2", [
            { no: 1, name: "consensus_parameters", kind: "message", T: () => exports.ConsensusParametersV1 },
            { no: 2, name: "euro_per_energy", kind: "message", T: () => exports.ExchangeRate },
            { no: 3, name: "micro_ccd_per_euro", kind: "message", T: () => exports.ExchangeRate },
            { no: 4, name: "cooldown_parameters", kind: "message", T: () => exports.CooldownParametersCpv1 },
            { no: 5, name: "time_parameters", kind: "message", T: () => exports.TimeParametersCpv1 },
            { no: 6, name: "account_creation_limit", kind: "message", T: () => exports.CredentialsPerBlockLimit },
            { no: 7, name: "mint_distribution", kind: "message", T: () => exports.MintDistributionCpv1 },
            { no: 8, name: "transaction_fee_distribution", kind: "message", T: () => exports.TransactionFeeDistribution },
            { no: 9, name: "gas_rewards", kind: "message", T: () => exports.GasRewardsCpv2 },
            { no: 10, name: "foundation_account", kind: "message", T: () => exports.AccountAddress },
            { no: 11, name: "pool_parameters", kind: "message", T: () => exports.PoolParametersCpv1 },
            { no: 12, name: "root_keys", kind: "message", T: () => exports.HigherLevelKeys },
            { no: 13, name: "level1_keys", kind: "message", T: () => exports.HigherLevelKeys },
            { no: 14, name: "level2_keys", kind: "message", T: () => exports.AuthorizationsV1 },
            { no: 15, name: "finalization_committee_parameters", kind: "message", T: () => exports.FinalizationCommitteeParameters }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ChainParametersV2
 */
exports.ChainParametersV2 = new ChainParametersV2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChainParameters$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.ChainParameters", [
            { no: 1, name: "v0", kind: "message", oneof: "parameters", T: () => exports.ChainParametersV0 },
            { no: 2, name: "v1", kind: "message", oneof: "parameters", T: () => exports.ChainParametersV1 },
            { no: 3, name: "v2", kind: "message", oneof: "parameters", T: () => exports.ChainParametersV2 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.ChainParameters
 */
exports.ChainParameters = new ChainParameters$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizationSummaryParty$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.FinalizationSummaryParty", [
            { no: 1, name: "baker", kind: "message", T: () => exports.BakerId },
            { no: 2, name: "weight", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "signed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.FinalizationSummaryParty
 */
exports.FinalizationSummaryParty = new FinalizationSummaryParty$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizationIndex$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.FinalizationIndex", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.FinalizationIndex
 */
exports.FinalizationIndex = new FinalizationIndex$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizationSummary$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.FinalizationSummary", [
            { no: 1, name: "block", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "index", kind: "message", T: () => exports.FinalizationIndex },
            { no: 3, name: "delay", kind: "message", T: () => exports.BlockHeight },
            { no: 4, name: "finalizers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.FinalizationSummaryParty }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.FinalizationSummary
 */
exports.FinalizationSummary = new FinalizationSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockFinalizationSummary$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockFinalizationSummary", [
            { no: 1, name: "none", kind: "message", oneof: "summary", T: () => exports.Empty },
            { no: 2, name: "record", kind: "message", oneof: "summary", T: () => exports.FinalizationSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockFinalizationSummary
 */
exports.BlockFinalizationSummary = new BlockFinalizationSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockItem$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockItem", [
            { no: 1, name: "hash", kind: "message", T: () => exports.TransactionHash },
            { no: 2, name: "account_transaction", kind: "message", oneof: "blockItem", T: () => exports.AccountTransaction },
            { no: 3, name: "credential_deployment", kind: "message", oneof: "blockItem", T: () => exports.CredentialDeployment },
            { no: 4, name: "update_instruction", kind: "message", oneof: "blockItem", T: () => exports.UpdateInstruction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockItem
 */
exports.BlockItem = new BlockItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BakerRewardPeriodInfo$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BakerRewardPeriodInfo", [
            { no: 1, name: "baker", kind: "message", T: () => exports.BakerInfo },
            { no: 2, name: "effective_stake", kind: "message", T: () => exports.Amount },
            { no: 3, name: "commission_rates", kind: "message", T: () => exports.CommissionRates },
            { no: 4, name: "equity_capital", kind: "message", T: () => exports.Amount },
            { no: 5, name: "delegated_capital", kind: "message", T: () => exports.Amount },
            { no: 6, name: "is_finalizer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BakerRewardPeriodInfo
 */
exports.BakerRewardPeriodInfo = new BakerRewardPeriodInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuorumSignature$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.QuorumSignature", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.QuorumSignature
 */
exports.QuorumSignature = new QuorumSignature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuorumCertificate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.QuorumCertificate", [
            { no: 1, name: "block_hash", kind: "message", T: () => exports.BlockHash },
            { no: 2, name: "round", kind: "message", T: () => exports.Round },
            { no: 3, name: "epoch", kind: "message", T: () => exports.Epoch },
            { no: 4, name: "aggregate_signature", kind: "message", T: () => exports.QuorumSignature },
            { no: 5, name: "signatories", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BakerId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.QuorumCertificate
 */
exports.QuorumCertificate = new QuorumCertificate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinalizerRound$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.FinalizerRound", [
            { no: 1, name: "round", kind: "message", T: () => exports.Round },
            { no: 2, name: "finalizers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.BakerId }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.FinalizerRound
 */
exports.FinalizerRound = new FinalizerRound$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoutSignature$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TimeoutSignature", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TimeoutSignature
 */
exports.TimeoutSignature = new TimeoutSignature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoutCertificate$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.TimeoutCertificate", [
            { no: 1, name: "round", kind: "message", T: () => exports.Round },
            { no: 2, name: "min_epoch", kind: "message", T: () => exports.Epoch },
            { no: 3, name: "qc_rounds_first_epoch", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.FinalizerRound },
            { no: 4, name: "qc_rounds_second_epoch", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => exports.FinalizerRound },
            { no: 5, name: "aggregate_signature", kind: "message", T: () => exports.TimeoutSignature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.TimeoutCertificate
 */
exports.TimeoutCertificate = new TimeoutCertificate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SuccessorProof$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.SuccessorProof", [
            { no: 1, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.SuccessorProof
 */
exports.SuccessorProof = new SuccessorProof$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EpochFinalizationEntry$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.EpochFinalizationEntry", [
            { no: 1, name: "finalized_qc", kind: "message", T: () => exports.QuorumCertificate },
            { no: 2, name: "successor_qc", kind: "message", T: () => exports.QuorumCertificate },
            { no: 3, name: "successor_proof", kind: "message", T: () => exports.SuccessorProof }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.EpochFinalizationEntry
 */
exports.EpochFinalizationEntry = new EpochFinalizationEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockCertificates$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.BlockCertificates", [
            { no: 1, name: "quorum_certificate", kind: "message", T: () => exports.QuorumCertificate },
            { no: 2, name: "timeout_certificate", kind: "message", T: () => exports.TimeoutCertificate },
            { no: 3, name: "epoch_finalization_entry", kind: "message", T: () => exports.EpochFinalizationEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.BlockCertificates
 */
exports.BlockCertificates = new BlockCertificates$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WinningBaker$Type extends runtime_1.MessageType {
    constructor() {
        super("concordium.v2.WinningBaker", [
            { no: 1, name: "round", kind: "message", T: () => exports.Round },
            { no: 2, name: "winner", kind: "message", T: () => exports.BakerId },
            { no: 3, name: "present", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message concordium.v2.WinningBaker
 */
exports.WinningBaker = new WinningBaker$Type();
